import {
  Box,
  FormControl,
  Button,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Autocomplete,
  Backdrop,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import { useFormik } from "formik";
import * as Yup from "yup";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import FormSubmissionSuccessDialog from "../../../components/FormSubmissionSuccessDialog/FormSubmissionSuccessDialog";
import { cfpBaseUrl } from "../../../network/urls";
import AppLoader from '../../../components/AppLoader/AppLoader';
import pdfIcon from "../../../images/pdfIcon.png";
import affidavitImage from "../../../images/afidavit.png"; // path adjust according to your file

//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import SUNDARLOGO from "../../../images/discologos/sundar-logo.png";

import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../../images/pitc.png";
import MEPCOWaterMark from "../../../images/DiscosWater/mepcco-watermark.png";
import LESCOWaterMark from "../../../images/DiscosWater/lescowatermark.png";
import IESCOWaterMark from "../../../images/DiscosWater/iescowatermark.png";
import FESCOWaterMark from "../../../images/DiscosWater/fesco-watermark.png";
import GEPCOWaterMark from "../../../images/DiscosWater/gepco-watermark.png";
import HAZECOWaterMark from "../../../images/DiscosWater/hazeco-watermark.png";
import HESCOWaterMark from "../../../images/DiscosWater/hesco-watermark.png";
import TESCOWaterMark from "../../../images/DiscosWater/tesco-watermark.png";
import SEPCOWaterMark from "../../../images/DiscosWater/sepco-watermark.png";
import PESCOWaterMark from "../../../images/DiscosWater/pesco-watermark.png";
import QESCOWaterMark from "../../../images/DiscosWater/qesco-watermark.png";
// Portal Name
import { documentExtensions, portalName } from "../../../utils/PortalName";
import { resolveDiscoCompanyCodeForBranding } from "../../../utils/adminCompany";
import CloseIcon from "@mui/icons-material/Close";
import Error from "../../../components/error/error";
import "./NewConnectionForm.scss";
import {
  isImage,
  isPdf,
  subdivisionName,
  handleFileUpload,
  companyShortName,
  subDivAPI,
  filterOptions,
  dBillAPI,
} from "../../../services/Functions";
import { useNavigate } from "react-router-dom";
import useFetchData from "../../../hooks/fetchData";
import { useSelector } from "react-redux";
import StepProgressBar from "../../../components/StepProgressBarForm/StepProgressBar";
import LocationPicker from "../../../components/LocationPicker/LocationPicker";

export const initialValues = {
  // Classification group Initial Values
  iv_connection_type: "Domestic",
  iv_applied_load: "",
  iv_near_by_reference_no: "",
  iv_near_by_name: "",
  iv_near_by_address: "",
  iv_circle: "",
  iv_division: "",
  iv_sub_divison: "",
  // Applicant Details group Initial Values
  iv_applicant_status: "Owner",
  iv_relation_type: "",
  iv_relative_name: "",
  iv_meter_seasonal: 0,
  iv_applicant_name: "",
  iv_applicant_citizenship: "Pakistani",
  iv_applicant_cnic: "",
  iv_applicant_phone_no: "",
  iv_applicant_email: "",
  iv_ntn: "",
  iv_strn: "",
  // Owner Details group Initial Values
  iv_owner_name: "",
  iv_owner_cnic: "",
  iv_owner_phone_no: "",
  iv_owner_email: "",
  // Address Group Initial Values
  iv_area_type: "Urban",
  iv_city_district: null,
  iv_address: "",
  iv_meter_installed: 0,
  iv_town_tehsil: "",
  // Required Documents Initial Values
  iv_applicant_cnic_document_front: null,
  iv_applicant_cnic_document_back: null,
  iv_property_documents: null,
  iv_near_by_bill: null,
  iv_any_other_document: null,
  iv_owner_cnic_document_front: null,
  iv_owner_cnic_document_back: null,
  iv_noc_owner: null,
  iv_resolution: null,
  iv_memo: null,
  iv_form29initial: null,
};

export const applicantStatusForValidation = ["Owner", "Tenant"];
export const applicantCitizenshipForValidation = ["Pakistani", "Foreigner"];
export const areaTypeForValidation = ["Urban", "Rural"];

const COMMERCIAL_INDUSTRIAL_CONNECTION_TYPES = ["Industrial", "Commercial"];

const STANDARD_CONNECTION_TYPES = [
  "Domestic",
  "Agriculture",
  "Temporary",
  "General Services",
  "Electrification",
  "Public Lightning",
  "Corporate Company",
  "Residential Colony attached to Industry",
  "Tubewell",
  "Railway Tracking",
  "EV Charging Station",
  "Electric Vehicles Charging Station",
  "Wapda Employee",
];

const isStandardConnectionType = (connectionType, connectionTypesList = []) =>
  STANDARD_CONNECTION_TYPES.includes(connectionType) ||
  (connectionTypesList.some(
    (type) => type.connectionTypeName === connectionType,
  ) &&
    !COMMERCIAL_INDUSTRIAL_CONNECTION_TYPES.includes(connectionType));

const NewConnectionForm = () => {
  let navigate = useNavigate();
  // Classification Group States
  const [connectionType, setConnectionType] = useState("Domestic");
  const [connectionTypesList, setConnectionTypesList] = useState([]);
  const [nearByReferenceNumber, setNearByReferenceNumber] = useState("");
  const [, setNearByName] = useState("");
  const [, setNearByAddress] = useState("");
  const [subDivision, setSubDivision] = React.useState({
    code: null,
    name: "",
  });
  const [error, setError] = useState();
  // Documents states
  const [applicantCnicDocumentFront, setApplicantCnicDocumentFront] =
    useState("");
  const [applicantCnicDocumentBack, setApplicantCnicDocumentBack] =
    useState("");
  const [propertyDocuments, setPropertDocuments] = useState("");
  const [nearByBillDocument, setNearByBillDocument] = useState("");
  const [anyOtherDocument, setAnyOtherDocument] = useState("");
  const [testWiringReportDocument, setTestWiringReportDocument] = useState("");
  const [nocOwnerDocument, setNocOwnerDocument] = useState("");
  const [ownerCnicDocumentFront, setOwnerCnicDocumentFront] = useState("");
  const [ownerCnicDocumentBack, setOwnerCnicDocumentBack] = useState("");
  const [resolutionDocument, setResolutionDocument] = useState("");
  const [memorandumDocument, setMemorandumDocument] = useState("");
  const [form29Document, setForm29Document] = useState("");
  const [newConnectionPopup, setNewConnectionPopup] = useState(false);
  const [applicantCnicFrontError, setApplicantCnicFrontError] = useState("");
  const [applicantCnicBackError, setApplicantCnicBackError] = useState("");
  const [propertyDocumentError, setPropertyDocumentError] = useState("");
  const [nearByBillError, setNearByBillError] = useState("");
  const [anyOtherDocumentError, setAnyOtherDocumentError] = useState("");
  const [testWiringReportDocumentError, setTestWiringReportDocumentError] = useState("");
  const [referenceNumberError, setReferenceNumberError] = useState("");
  const [bodError, setBodError] = useState("");
  const [memorandumError, setMemorandumError] = useState("");
  const [formError, setFormError] = useState("");
  const [ownerCnicFrontError, setOwnerCnicFrontError] = useState("");
  const [ownerCnicBackError, setOwnerCnicBackError] = useState("");
  const [nocError, setNocError] = useState("");

  const errorCloses = () => {
    setError("");
  };

  // Thumbnail states
  const [
    applicantCnicDocumentFrontThumbnail,
    setApplicantCnicDocumentFrontThumbnail,
  ] = useState("");
  const [
    applicantCnicDocumentBackThumbnail,
    setApplicantCnicDocumentBackThumbnail,
  ] = useState("");
  const [propertyDocumentsThumbnail, setPropertyDocumentsThumbnail] =
    useState("");
  const [nearByBillDocumentThumbnail, setNearByBillDocumentThumbnail] =
    useState("");
  const [anyOtherDocumentThumbnail, setAnyOtherDocumentThumbnail] =
    useState("");
  const [testWiringReportDocumentThumbnail, setTestWiringReportDocumentThumbnail] =
    useState("");
  const [nocOwnerDocumentThumbnail, setNocOwnerDocumentThumbnail] =
    useState("");
  const [ownerCnicDocumentFrontThumbnail, setOwnerCnicDocumentFrontThumbnail] =
    useState("");
  const [ownerCnicDocumentBackThumbnail, setOwnerCnicDocumentBackThumbnail] =
    useState("");
  const [resolutionDocumentThumbnail, setResolutionDocumentThumbnail] =
    useState("");
  const [memorandumDocumentThumbnail, setMemorandumDocumentThumbnail] =
    useState("");
  const [form29DocumentThumbnail, setForm29DocumentThumbnail] = useState("");
  const [showLocationPicker, setShowLocationPicker] = useState(false);

  const [viewBackdrop, setViewBackdrop] = useState(false);

  // States for hiding conditional fields
  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState(null);
  const [defaultDivision, setDefaultDivision] = useState(null);
  const [phase, setPhase] = useState();
  const [tariff, setTariff] = useState();
  const [showTooltip, setShowTooltip] = useState(false);
  const [newConnectionId, setNewConnectionId] = useState("");
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case "11":
        return LESCOWaterMark;
      case "12":
        return GEPCOWaterMark;
      case "13":
        return FESCOWaterMark;
      case "14":
        return IESCOWaterMark;
      case "15":
        return MEPCOWaterMark;
      case "26":
        return PESCOWaterMark;
      case "27":
        return HAZECOWaterMark;
      case "37":
        return HESCOWaterMark;
      case "38":
        return SEPCOWaterMark;
      case "48":
        return QESCOWaterMark;
      case "59":
        return TESCOWaterMark;
      default:
        return MEPCOWaterMark;
    }
  };
  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      case "91":
        return SUNDARLOGO;
      default:
        return MEPCOLOGO;
    }
  };
  const handleFocus = () => {
    setShowTooltip(true);
  };

  const {
    token,
    code: userCode,
    userId,
    name: userName,
    roleName: userRole,
    roleTypeId,
    roleId,
    selectedAdminCompanyCode,
  } = useSelector((state) => state.auth);
  const isDiscoAdmin = String(userCode) === "10";
  const [subDivList, setSubDivList] = useState(
    () => JSON.parse(window.localStorage.getItem("subDivisions")) || [],
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState(
    isDiscoAdmin && selectedAdminCompanyCode
      ? String(selectedAdminCompanyCode)
      : String(userCode).slice(0, 2),
  );
  let userCompany = resolveDiscoCompanyCodeForBranding(
    userCode,
    roleId,
    selectedCompanyCode || selectedAdminCompanyCode,
  );

  const myHeaders = new Headers();
  myHeaders.append("Authorization", token);

  const RequestOptions = (method, myHeaders) => {
    return {
      method: method,
      headers: myHeaders,
      redirect: "follow",
    };
  };

  let requestOptions = RequestOptions("GET", myHeaders);
  const {
    data: cities,
    loading: citiesLoading,
    error: citiesError,
  } = useFetchData(
    roleTypeId == 1 ? cfpBaseUrl + "electricityNewConnection/citiesList" : null,
    requestOptions,
  );
  requestOptions = RequestOptions("POST", myHeaders);
  const {
    data: tariffs,
    loading: tariffsLoading,
    error: tariffsError,
  } = useFetchData(
    roleTypeId == 1
      ? cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail"
      : null,
    requestOptions,
  );

  // Formik form submission and new connection API calling
  const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } =
    useFormik({
      initialValues,
      validationSchema: Yup.object().shape({
        // Classification group Validations
        iv_connection_type: Yup.mixed()
          .required("Please select connection type.")
          .test(
            "valid-connection-type",
            "Please select a valid option",
            function (value) {
              if (!value) return false;
              // If API list is loaded, validate against it; otherwise allow any non-empty value
              if (connectionTypesList.length > 0) {
                return connectionTypesList.some(
                  (type) => type.connectionTypeName === value,
                );
              }
              return true;
            },
          ),
        iv_applied_load: Yup.number()
          .typeError("Please enter a valid load value.")
          .min(0.1, "Applied load must be at least 0.1 kW.")
          .required("Please enter applied load.")
          .when("iv_connection_type", {
            is: "Domestic",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .max(1000, "Residential Maximum Load 1000kW.")
              .required("Please enter applied load."),
          })
          .when("iv_connection_type", {
            is: "Commercial",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .max(5000, "Commercial Maximum Load 5000kW.")
              .required("Please enter applied load."),
          })
          .when("iv_connection_type", {
            is: "Industrial",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .required("Please enter applied load."),
          })
          .when("iv_connection_type", {
            is: "Agriculture",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .max(5000, "Applied load cannot be more than 5000kW.")
              .required("Please enter applied load."),
          })
          .when("iv_connection_type", {
            is: "Temporary",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .max(5000, "Applied load cannot be more than 5000kW.")
              .required("Please enter applied load."),
          })
          .when("iv_connection_type", {
            is: "GeneralServices",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .max(5000, "Applied load cannot be more than 5000kW.")
              .required("Please enter applied load."),
          })
          .when("iv_connection_type", {
            is: "Electrification",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .max(5000, "Applied load cannot be more than 5000kW.")
              .required("Please enter applied load."),
          })
          .when("iv_connection_type", {
            is: "StreetLight",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .max(5000, "Applied load cannot be more than 5000kW.")
              .required("Please enter applied load."),
          })
          .when("iv_connection_type", {
            is: "CorporateCompany",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .max(5000, "Applied load cannot be more than 5000kW.")
              .required("Please enter applied load."),
          })
          .when("iv_area_type", {
            is: "Urban",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .max(5000, "Applied load cannot be more than 5000kW.")
              .required("Please enter applied load."),
          })
          .when("iv_area_type", {
            is: "Rural",
            then: Yup.number()
              .typeError("Please enter a valid load value.")
              .min(0.1, "Applied load must be at least 0.1 kW.")
              .max(5000, "Applied load cannot be more than 5000kW.")
              .required("Please enter applied load."),
          }),
        iv_near_by_reference_no: Yup.string()
          .min(14, "Please enter 14 digit reference number.")
          .max(14, "Please enter 14 digit reference number.")
          .matches(
            /^[0-9]+$/,
            "Enter 14 digit reference number as 01234567891234",
          )
          .optional(),
        iv_near_by_name: Yup.string().optional(),
        iv_near_by_address: Yup.string().optional(),
        iv_circle: Yup.mixed().required("Please select a circle."),
        iv_division: Yup.mixed().required("Please select a division."),
        iv_sub_divison: Yup.mixed().required("Please select a sub division."),
        iv_applicant_status: Yup.mixed()
          .required("Please select applicant status.")
          .oneOf(applicantStatusForValidation, "Please select a valid option"),
        iv_meter_seasonal: Yup.mixed().required(
          "Please select Meter seasonal type.",
        ),
        iv_applicant_name: Yup.string()
          .min(3, "Name should be atleast 3 characters.")
          .max(30, "Name should be less than 30 characters.")
          .required("Please enter applicant name.")
          .matches(/^[A-Za-z. ]*$/, "Only letters and '.' are allowed."),
        iv_applicant_cnic: Yup.string()
          .length(13, "Please enter 13 digit CNIC.")
          .required("Please enter valid CNIC number.")
          .matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678.")
          .test(
            "not-all-same",
            "CNIC cannot contain all identical digits.",
            (value) => {
              if (!value) return true;
              return !/^(\d)\1{12}$/.test(value);
            },
          )
          .test("not-all-zero", "CNIC cannot be 0000000000000.", (value) => {
            if (!value) return true;
            return value !== "0000000000000";
          }),
        iv_applicant_citizenship: Yup.mixed()
          .required("Please select citizenship.")
          .oneOf(
            applicantCitizenshipForValidation,
            "Please select a valid option",
          ),
        iv_applicant_phone_no: Yup.string()
          .max(11, "Please enter 11 digit phone number.")
          .min(11, "Please enter 11 digit phone number.")
          .required("Please enter valid mobile number.")
          .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
        iv_applicant_email: Yup.string()
          .email("Enter email as 'john@gmail.com'.")
          .notRequired(),
        iv_relation_type: Yup.string()
          .required("Please select relation type.")
          .oneOf(["S/O", "D/O", "W/O", "C/O"], "Please select relation type."),
        iv_relative_name: Yup.string()
          .min(3, "Name should be atleast 3 characters.")
          .max(30, "Name should be less than 30 characters.")
          .required("Please enter relative name.")
          .matches(/^[A-Za-z. ]*$/, "Only letters and '.' are allowed."),
        iv_ntn: Yup.string().when("iv_connection_type", {
          is: (iv_connection_type) =>
            iv_connection_type === "Industrial" ||
            iv_connection_type === "Commercial" ||
            iv_connection_type === "Corporate Company",
          then: Yup.string()
            .required("Please enter valid NTN.")
            .matches(/^\d+$/, "NTN. must contain digits only.")
            .min(7, "NTN. should be atleast 7 digits.")
            .max(13, "NTN. should be 13 digits."),
          otherwise: Yup.string().optional(),
        }),
        // STRN
        iv_strn: Yup.string().when("iv_connection_type", {
          is: (iv_connection_type) =>
            iv_connection_type === "Industrial" ||
            iv_connection_type === "Commercial" ||
            iv_connection_type === "Corporate Company",
          then: Yup.string()
            .required("Please enter valid STRN.")
            .matches(/^\d+$/, "STRN. must contain digits only.")
            .max(13, "STRN. should be 13 digits.")
            .min(13, "STRN. should be 13 digits."),
          otherwise: Yup.string().optional(),
        }),
        iv_owner_name: Yup.string().when("iv_applicant_status", {
          is: (iv_applicant_status) => iv_applicant_status === "Tenant",
          then: Yup.string()
            .max(30)
            .required("Please enter valid owner name.")
            .matches(/^[A-Za-z. ]*$/, "Only letters and '.' are allowed."),
          otherwise: Yup.string(),
        }),
        iv_owner_cnic: Yup.string().when("iv_applicant_status", {
          is: (iv_applicant_status) => iv_applicant_status === "Tenant",
          then: Yup.string()
            .min(13, "Please enter 13 digit CNIC.")
            .max(13, "Please enter 13 digit CNIC.")
            .required("Please enter valid CNIC number.")
            .matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
          otherwise: Yup.string(),
        }),
        iv_owner_phone_no: Yup.string().when("iv_applicant_status", {
          is: (iv_applicant_status) => iv_applicant_status === "Tenant",
          then: Yup.string()
            .max(11, "Please enter 11 digit phone number.")
            .min(11, "Please enter 11 digit phone number.")
            .required("Please enter valid mobile number.")
            .matches(
              /^03[0-9]{2}[0-9]{7}$/,
              "Enter Phone number as 03001234567",
            ),
          otherwise: Yup.string(),
        }),
        // Owner Email
        iv_owner_email: Yup.string().when("iv_applicant_status", {
          is: (iv_applicant_status) => iv_applicant_status === "Tenant",
          then: Yup.string()
            .email("Enter email as 'john@gmail.com'.")
            .optional(),
          otherwise: Yup.string(),
        }),
        // Address group Validations
        iv_area_type: Yup.mixed()
          .required("Please select area type.")
          .oneOf(areaTypeForValidation, "Please select a valid option"),
        iv_meter_installed: Yup.number()
          .typeError("Please enter valid no of meters already installed.")
          .integer("Only whole number is allowed.")
          .min(0, "No of meters cannot be negative.")
          .required("Please enter no of meters already installed."),
        iv_city_district: Yup.string()
          .nullable()
          .oneOf(cities || [], "Please select a valid option")
          .required("Please select a city."),
        // Urban
        iv_address: Yup.string().when("iv_area_type", {
          is: "Urban", // Checks if iv_area_type is "Urban"
          then: Yup.string()
            .required("Enter address.")
            .max(40, `Address can't be more than 40 characters.`),
          otherwise: Yup.string()
            .required("Enter address.") // Applies for non-Urban values
            .max(30, `Address can't be more than 30 characters.`),
        }),
        iv_town_tehsil: Yup.string().when("iv_area_type", {
          is: (iv_area_type) => iv_area_type === "Rural",
          then: Yup.string()
            .max(15, "Tehsil must be less than 15 character")
            .required("Please enter town.")
            .matches(
              /^[a-zA-Z0-9/#\s]*$/,
              "Town must be alphanumeric characters only.",
            ),
          otherwise: Yup.string(),
        }),
        // Required Documents Validation
        iv_applicant_cnic_document_front: Yup.mixed().required(
          "Please upload CNIC Front image in jpg, jpeg, png or pdf format.",
        ),
        iv_applicant_cnic_document_back: Yup.mixed().required(
          "Please upload CNIC Back image in jpg, jpeg, png or pdf format.",
        ),
        iv_property_documents: Yup.mixed().required(
          "Please upload property documents in jpg, jpeg, png or pdf format.",
        ),
        iv_near_by_bill: Yup.mixed().required(
          "Please upload near by electricity bill in jpg, jpeg, png or pdf format.",
        ),
        iv_test_wiring_report: Yup.mixed()
          .nullable()
          .when("iv_connection_type", (iv_connection_type, schema) => {
            if (iv_connection_type === "Temporary" || iv_connection_type === "Electrification") {
              return schema.notRequired();
            }
            return schema.required(
              "Please upload Wiring Test Report in jpg, jpeg, png or pdf format.",
            );
          }),
        iv_any_other_document: Yup.mixed()
          .nullable()
          .when("iv_circle", (iv_circle, schema) => {
            // Convert to string and check first 2 digits
            if (iv_circle && iv_circle.toString().startsWith("14")) {
              return schema.required(
                "Please upload additional document in jpg, jpeg, png or pdf format.",
              );
            }
            return schema.notRequired(); // optional for others
          }),
        iv_owner_cnic_document_front: Yup.mixed().when("iv_applicant_status", {
          is: (iv_applicant_status) => iv_applicant_status === "Tenant",
          then: Yup.mixed().required(
            "Please upload CNIC Front in jpg, jpeg, png or pdf format.",
          ),
          otherwise: Yup.mixed(),
        }),
        iv_owner_cnic_document_back: Yup.mixed().when("iv_applicant_status", {
          is: (iv_applicant_status) => iv_applicant_status === "Tenant",
          then: Yup.mixed().required(
            "Please upload CNIC Back in jpg, jpeg, png or pdf format.",
          ),
          otherwise: Yup.mixed(),
        }),
        iv_noc_owner: Yup.mixed().when("iv_applicant_status", {
          is: (iv_applicant_status) => iv_applicant_status === "Tenant",
          then: Yup.mixed().required(
            "Please upload NoC in jpg, jpeg, png or pdf format.",
          ),
          otherwise: Yup.mixed(),
        }),
        iv_resolution: Yup.mixed().when("iv_connection_type", {
          is: (iv_connection_type) => iv_connection_type === "Industrial",
          then: Yup.mixed().required(
            "Please upload resolution form in jpg, jpeg, png or pdf format.",
          ),
          otherwise: Yup.mixed(),
        }),
        iv_memo: Yup.mixed()
          .nullable()
          .notRequired(
            "Please upload MoA Certificate in jpg, jpeg, png or pdf format.",
          ),
        iv_form29initial: Yup.mixed().when("iv_connection_type", {
          is: (iv_connection_type) => iv_connection_type === "Industrial",
          then: Yup.mixed().required(
            "Please upload Form 29 in jpg, jpeg, png or pdf format.",
          ),
          otherwise: Yup.mixed(),
        }),
      }),
      onSubmit: async (values, { resetForm }) => {
        setViewBackdrop(true);
        var formdata = new FormData();
        formdata.append("createdBy", userId);
        formdata.append("assignedTo", "");
        formdata.append("approvedBy", "");
        formdata.append("applicationStatusId", 1);
        formdata.append("lastModifiedBy", "");
        formdata.append("remarks", "");
        formdata.append("remarksDetail", "");
        formdata.append("isOnline", 1);
        formdata.append("submittedThrough", portalName);
        formdata.append("subDivisionCode", subDivision.code);
        formdata.append("divisionCode", defaultDivision.code);
        formdata.append("circleCode", defaultCircle.code);
        formdata.append(
          "companyCode",
          parseInt(defaultCircle.code.toString().slice(0, 2)),
        );
        formdata.append("withDrawlStatus", "");
        formdata.append("termAndConditionFlag", "yes");
        formdata.append("nearByReferenceNumber", nearByReferenceNumber);
        formdata.append("nearByName", values.iv_near_by_name);
        formdata.append("nearByAddress", values.iv_near_by_address);
        formdata.append("connectionType", connectionType);
        formdata.append("applicantStatus", values.iv_applicant_status);
        formdata.append("applicantName", values.iv_applicant_name);
        formdata.append("applicantCNIC", values.iv_applicant_cnic);
        formdata.append("applicantMobile", values.iv_applicant_phone_no);
        formdata.append("applicantEmail", values.iv_applicant_email);
        formdata.append(
          "applicantCitizenship",
          values.iv_applicant_citizenship,
        );
        formdata.append("relationType", values.iv_relation_type);
        formdata.append("relativeName", values.iv_relative_name);
        formdata.append("seasonalNonSeasonalFlag", values.iv_meter_seasonal);
        formdata.append("premisesAddress", values.iv_address);
        formdata.append("appliedLoad", values.iv_applied_load);
        if (
          values.iv_applicant_status === "Owner" ||
          values.iv_applicant_status === "owner"
        ) {
          formdata.append("ownerName", values.iv_applicant_name);
          formdata.append("ownerCNIC", values.iv_applicant_cnic);
          formdata.append("ownerMobile", values.iv_applicant_phone_no);
          formdata.append("ownerEmail", values.iv_applicant_email);
        } else if (
          values.iv_applicant_status === "Tenant" ||
          values.iv_applicant_status === "tenant"
        ) {
          formdata.append("ownerName", values.iv_owner_name);
          formdata.append("ownerCNIC", values.iv_owner_cnic);
          formdata.append("ownerMobile", values.iv_owner_phone_no);
          formdata.append("ownerEmail", values.iv_owner_email);
        }
        formdata.append(
          "noOfMetersAlreadyInstalled",
          values.iv_meter_installed,
        );
        formdata.append("areaType", values.iv_area_type);
        formdata.append("houseNo", "");
        formdata.append("streetNo", "");
        formdata.append("townTehsil", values.iv_town_tehsil);
        formdata.append("cityDistrict", values.iv_city_district);
        formdata.append("NTN", values.iv_ntn);
        formdata.append("STRN", values.iv_strn);
        formdata.append("premisesDocument", propertyDocumentsThumbnail);
        formdata.append(
          "copyOfApplicantCNICFront",
          applicantCnicDocumentFrontThumbnail,
        );
        formdata.append(
          "copyOfApplicantCNICBack",
          applicantCnicDocumentBackThumbnail,
        );
        formdata.append(
          "scannedCopyOfNearByElectricityBill",
          nearByBillDocumentThumbnail,
        );
        formdata.append("wiringTestReportDocument", testWiringReportDocumentThumbnail);
        formdata.append("anyOtherDocument", anyOtherDocumentThumbnail);
        formdata.append("resolutionFormDesc", resolutionDocumentThumbnail);
        formdata.append("certMemoDesc", memorandumDocumentThumbnail);
        formdata.append("certFormDesc", form29DocumentThumbnail);
        formdata.append("ownerNOC", nocOwnerDocumentThumbnail);
        formdata.append(
          "copyOfOwnerCNICFront",
          ownerCnicDocumentFrontThumbnail,
        );
        formdata.append("copyOfOwnerCNICBack", ownerCnicDocumentBackThumbnail);
        formdata.append("applicationProgressId", 1);
        formdata.append("cfcId", userCode);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        var requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow",
        };
        await fetch(
          cfpBaseUrl + "electricityNewConnection/electricityNewConnections",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            const msg = result.message;
            if (result.status === "200") {
              const applicationID = result.applicationNo;
              setNewConnectionPopup(true);
              setNewConnectionId(result.applicationNo);
              setDefaultCircle();
              setDefaultDivision();
              setSubDivision();
              setApplicantCnicDocumentFront();
              setApplicantCnicDocumentBack();
              setApplicantCnicDocumentFrontThumbnail();
              setApplicantCnicDocumentBackThumbnail();
              setPropertDocuments();
              setPropertyDocumentsThumbnail();
              setNearByBillDocument();
              setAnyOtherDocument();
              setTestWiringReportDocument();
              setNearByBillDocumentThumbnail();
              setTestWiringReportDocumentThumbnail();
              setOwnerCnicDocumentFront();
              setOwnerCnicDocumentFrontThumbnail();
              setOwnerCnicDocumentBack();
              setOwnerCnicDocumentBackThumbnail();
              setNearByAddress("");
              setNearByName("");
              setNocOwnerDocument();
              setNocOwnerDocumentThumbnail();
              setResolutionDocument();
              setResolutionDocumentThumbnail();
              setMemorandumDocument();
              setMemorandumDocumentThumbnail();
              setForm29Document();
              setPhase("");
              setTariff("");
              setForm29DocumentThumbnail();
              printApplicationReceipt(
                values,
                applicationID,
                userName,
                userRole,
                defaultCircle,
              );
              resetForm();
            } else if (result.status === "401") {
              setError(msg);
              if (
                (result.message = "Session has been expired, Sign in again.")
              ) {
                navigate("/");
              }
            }
          })
          .catch((error) => {
          });
        setViewBackdrop(false);
      },
    });

  const resetHierarchySelections = () => {
    setDefaultCircle(null);
    setDefaultDivision(null);
    setSubDivision({ code: null, name: "" });
    values.iv_circle = "";
    values.iv_division = "";
    values.iv_sub_divison = "";
    setReferenceNumberError("");
    setNearByName("");
    setNearByAddress("");
  };

  const loadHierarchyForCompany = async (companyCode) => {
    if (!companyCode || !token) return;
    setViewBackdrop(true);
    try {
      const formdata = new FormData();
      formdata.append("companyCode", companyCode);
      const response = await fetch(
        `${cfpBaseUrl}customerFaciliationPortal/subDivWithCompDetails`,
        {
          method: "POST",
          headers: { Authorization: token },
          body: formdata,
          redirect: "follow",
        },
      );
      if (!response.ok) {
        throw new Error("Failed to load company hierarchy");
      }
      const result = await response.json();
      if (result.status === "200" && Array.isArray(result.message)) {
        setSubDivList(result.message);
        const lists = await subDivAPI(result.message);
        setHierarchyList(lists.hierarchyList);
        setCircleList(lists.circleList);
        setDivisionList(lists.divisionList);
        setSubDivisionList(lists.subDivisionList);
        resetHierarchySelections();
      } else {
        throw new Error("No hierarchy data returned");
      }
    } catch (loadError) {
      setHierarchyList([]);
      setCircleList([]);
      setDivisionList([]);
      setSubDivisionList([]);
      resetHierarchySelections();
    } finally {
      setViewBackdrop(false);
    }
  };

  const handleCompanyChange = (event) => {
    const company = event.target.value;
    setSelectedCompanyCode(company);
    loadHierarchyForCompany(company);
  };

  useEffect(() => {
    if (isDiscoAdmin && selectedAdminCompanyCode) {
      setSelectedCompanyCode(String(selectedAdminCompanyCode));
    }
  }, [isDiscoAdmin, selectedAdminCompanyCode]);

  useEffect(() => {
    const loadSubDivs = async () => {
      if (!token) return;
      if (isDiscoAdmin) {
        const company = selectedCompanyCode || selectedAdminCompanyCode;
        if (company) {
          await loadHierarchyForCompany(company);
        }
        return;
      }
      if (userCompany && subDivList?.length) {
        setViewBackdrop(true);
        const lists = await subDivAPI(subDivList);
        setHierarchyList(lists.hierarchyList);
        setCircleList(lists.circleList);
        setDivisionList(lists.divisionList);
        setSubDivisionList(lists.subDivisionList);
        setViewBackdrop(false);
      }
    };
    loadSubDivs();
  }, [token]);

  // Fetch Connection Types from API
  useEffect(() => {
    const fetchConnectionTypes = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: "",
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "enc/getConnectionTypes",
          requestOptions,
        );
        const result = await response.json();

        if (result.status === "200" && result.data) {
          setConnectionTypesList(result.data);
        }
      } catch (error) { /* ignored */ }
    };

    if (token) {
      fetchConnectionTypes();
    }
  }, [token]);

  useEffect(() => {
    if (!hierarchyList || !defaultCircle) return;

    const uniqueDivisions = hierarchyList
      .filter((division) => division.circleCode === defaultCircle.code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(
          (d) => d.code === division.divisionCode,
        );
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) =>
      a.name.localeCompare(b.name, "en", { ignorePunctuation: true }),
    );

    setDivisionList(sortedDivisionArray);
  }, [defaultCircle, hierarchyList]);

  useEffect(() => {
    if (!defaultDivision || !hierarchyList) return;

    const uniqueSubDivisions = hierarchyList
      .filter(
        (subDivision) => subDivision.divisionCode === defaultDivision.code,
      )
      .reduce((uniqueSubDivisions, subDivision) => {
        const existingSubDivision = uniqueSubDivisions.find(
          (s) => s.code === subDivision.subDivisionCode,
        );
        if (!existingSubDivision) {
          uniqueSubDivisions.push({
            code: subDivision.subDivisionCode,
            name: subDivision.subDivisionName,
          });
        }
        return uniqueSubDivisions;
      }, []);

    const sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
      a.name.localeCompare(b.name, "en", { ignorePunctuation: true }),
    );

    setSubDivisionList(sortedSubDivisionArray);
  }, [defaultDivision, hierarchyList]);

  useEffect(() => {
    if (nearByReferenceNumber.length === 14) {
      let enteredReferenceNo = nearByReferenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);

      let circleObject = circleList.find(
        (item) => item.code === parseInt(circleCode),
      );

      if (!circleObject) {
        setReferenceNumberError(
          `Circle not found with code: ${circleCode}. Contact Admin!`,
        );
        setNearByName("");
        setNearByAddress("");
        setDefaultCircle("");
        setDefaultDivision("");
        setSubDivision("");
        return;
      }

      setDefaultCircle(circleObject);
      values.iv_circle = circleObject.code;

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(
            (c) => c.code === division.divisionCode,
          );
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
      );
      let defDivision = sortedDivisionArray.find(
        (item) => item.code === parseInt(divisionCode),
      );

      if (!defDivision) {
        setReferenceNumberError(
          `Division not found with code: ${divisionCode}. Contact Admin!`,
        );
        setNearByName("");
        setNearByAddress("");
        setDefaultDivision("");
        setSubDivision("");
        return;
      }

      setDefaultDivision(defDivision);
      values.iv_division = defDivision.code;
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(
            (c) => c.code === subDivision.subDivisionCode,
          );
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
      );

      let subDivisionObject = sortedSubDivisionArray.find(
        (item) => item.code === parseInt(subDivisionCode),
      );

      if (!subDivisionObject) {
        setReferenceNumberError(
          `Subdivision not found with code: ${subDivisionCode}. Contact Admin!`,
        );
        setNearByName("");
        setNearByAddress("");
        setSubDivision("");
        return;
      }

      values.iv_sub_divison = subDivisionObject.code;
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);

      referenceApi();
    } else {
      setReferenceNumberError("");
      setNearByName("");
      setNearByAddress("");
      setDefaultCircle("");
      setDefaultDivision("");
      setSubDivision("");
    }
  }, [nearByReferenceNumber]);

  const referenceApi = async () => {
    if (!nearByReferenceNumber) return;
    setViewBackdrop(true);
    let apiResult = await dBillAPI(token, nearByReferenceNumber);
    const basicInfo = apiResult.basicInfo;
    if (apiResult.status) {
      values.iv_near_by_name = basicInfo.consumerName;
      values.iv_near_by_address = (
        basicInfo.consumerAddress1 + basicInfo.consumerAddress2
      ).trimStart();
    } else if (apiResult.status == false) {
      setReferenceNumberError("No Data Found against this Reference number");
    } else {
      setReferenceNumberError("Reference number does not exist!");
    }
    setViewBackdrop(false);
  };

  const ConnectionType = (event) => {
    handleChange(event);
    setConnectionType(event.target.value);
  };

  const handleNumericChange = (event, fieldName, maxLength) => {
    const digitsOnly = event.target.value.replace(/\D/g, "").slice(0, maxLength);
    setFieldValue(fieldName, digitsOnly);
  };

  const NearByReferenceNumber = (event) => {
    handleChange(event);
    setNearByReferenceNumber(event.target.value);
  };

  const handleLoadChange = (event) => {
    let appliedLoad = event.target.value;
    handleChange(event);
    const loadValue = parseFloat(appliedLoad);

    if (values.iv_connection_type === "Industrial") {
      if (values.iv_meter_seasonal == 1) {
        const seasonalTariff = tariffs.data.find(
          (item) => item.tariffCode === "F",
        );
        // Check if seasonalTariff is found before setting the state
        if (seasonalTariff) {
          setTariff(seasonalTariff.tariffName || "");
        } else {
          // Handle the case when the seasonal tariff is not found
          setTariff("");
        }
        if (!Number.isNaN(loadValue) && loadValue <= 500) {
          setPhase("MDI (LT)(CT)");
        } else if (!Number.isNaN(loadValue) && loadValue > 500) {
          setPhase("MDI (HT)(CT/PT)");
        }
      } else if (values.iv_meter_seasonal == 0) {
        let shortListedTariffsArray = tariffs.data.filter(
          (item) => item.consumerType === connectionType,
        );
        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseFloat(item.from) <= loadValue &&
            parseFloat(item.to) > loadValue,
        );
        let selectedTariff = shortListedTariffsArray[0];
        // Check if seasonalTariff is found before setting the state
        if (selectedTariff) {
          setTariff(selectedTariff.tariffName || "");
        } else {
          // Handle the case when the seasonal tariff is not found
          setTariff("");
        }
        if (!Number.isNaN(loadValue) && loadValue <= 500) {
          setPhase("MDI (LT)(CT)");
        } else if (!Number.isNaN(loadValue) && loadValue > 500) {
          setPhase("MDI (HT)(CT/PT)");
        }
      }
    } else {
      if (!Number.isNaN(loadValue) && loadValue > 0) {
        let shortListedTariffsArray = (tariffs?.data || []).filter(
          (item) => item.consumerType == connectionType,
        );
        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseFloat(item.from) <= loadValue &&
            parseFloat(item.to) > loadValue,
        );
        const selectedTariff = shortListedTariffsArray[0];
        if (selectedTariff) {
          setTariff(selectedTariff.tariffName || "");
        } else {
          setTariff("");
        }
        if (loadValue < 5) {
          setPhase("Single Phase");
        } else if (loadValue >= 5 && loadValue < 20) {
          setPhase("3 Phase");
        } else if (loadValue >= 20 && loadValue < 500) {
          setPhase("MDI (LT)(CT)");
        } else if (loadValue >= 500) {
          setPhase("MDI (HT)(CT/PT)");
        }
      } else {
        setPhase("");
        setTariff("");
      }
    }
  };

  //Function to set states of documents
  const ApplicantCnicDocumentFront = (event) => {
    if (event.target.files) {
      const newFileName =
        "copyOfApplicantCNICFront." +
        event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setApplicantCnicDocumentFront,
        setApplicantCnicFrontError,
        setApplicantCnicDocumentFrontThumbnail,
        newFileName,
      );
    }
  };

  const ApplicantCnicDocumentBack = (event) => {
    if (event.target.files) {
      const newFileName =
        "copyOfApplicantCNICBack." +
        event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setApplicantCnicDocumentBack,
        setApplicantCnicBackError,
        setApplicantCnicDocumentBackThumbnail,
        newFileName,
      );
    }
  };

  const PropertDocuments = (event) => {
    if (event.target.files) {
      const newFileName =
        "copyOfPropertyDocument." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setPropertDocuments,
        setPropertyDocumentError,
        setPropertyDocumentsThumbnail,
        newFileName,
      );
    }
  };

  const NearByBillDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "scannedCopyOfNearByElectricityBill." +
        event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setNearByBillDocument,
        setNearByBillError,
        setNearByBillDocumentThumbnail,
        newFileName,
      );
    }
  };

  const AnyOtherDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "anyOtherDocument." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setAnyOtherDocument,
        setAnyOtherDocumentError,
        setAnyOtherDocumentThumbnail,
        newFileName,
      );
    }
  };

  const TestWiringReportDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "testWiringReport." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setTestWiringReportDocument,
        setTestWiringReportDocumentError,
        setTestWiringReportDocumentThumbnail,
        newFileName,
      );
    }
  };

  const NocOwnerDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "ownerNOC." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setNocOwnerDocument,
        setNocError,
        setNocOwnerDocumentThumbnail,
        newFileName,
      );
    }
  };

  const OwnerCnicDocumentFront = (event) => {
    if (event.target.files) {
      const newFileName =
        "copyOfOwnerCNIC." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setOwnerCnicDocumentFront,
        setOwnerCnicFrontError,
        setOwnerCnicDocumentFrontThumbnail,
        newFileName,
      );
    }
  };

  const OwnerCnicDocumentBack = (event) => {
    if (event.target.files) {
      const newFileName =
        "copyOfOwnerCNIC." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setOwnerCnicDocumentBack,
        setOwnerCnicBackError,
        setOwnerCnicDocumentBackThumbnail,
        newFileName,
      );
    }
  };

  const ResolutionDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "resolutionFormDesc." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setResolutionDocument,
        setBodError,
        setResolutionDocumentThumbnail,
        newFileName,
      );
    }
  };

  const MemorandumDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "certMemoDesc." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setMemorandumDocument,
        setMemorandumError,
        setMemorandumDocumentThumbnail,
        newFileName,
      );
    }
  };

  const Form29Document = (event) => {
    if (event.target.files) {
      const newFileName =
        "certFormDesc." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        handleChange,
        setForm29Document,
        setFormError,
        setForm29DocumentThumbnail,
        newFileName,
      );
    }
  };

  const printApplicationReceipt = (
    values,
    applicationID,
    userName,
    userRole,
    referenceNo,
  ) => {
    let DiscoCode = values.iv_sub_divison.toString().slice(0, 2);

    const doc = new jsPDF({ compressPdf: true });

    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;
    const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
    var pageWidth = doc.internal.pageSize.getWidth();

    const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
    const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
    const logoHeight1 = smallLogoCodes.includes(DiscoCode) ? 30 : 20;

    // Get page width

    // Calculate X position to center the logo
    const logoX = (pageWidth - logoWidth) / 2;
    // Add the barcode image to the PDF document

    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20);
    doc.addImage(
      getLogo(DiscoCode),
      "PNG",
      logoX,
      height,
      logoWidth,
      DiscoCode == "91" ? logoHeight1 : logoHeight,
    );

    if (DiscoCode === "91") {
      height = height + 30;
    } else {
      height = height + 20;
    }

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of New Connection Application",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      },
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(values.iv_circle.toString().slice(0, 2)),
      padding,
      height,
    );
    doc.text(
      values.iv_sub_divison.toString() +
        " / " +
        subdivisionName(values.iv_sub_divison, subDivList),
      padding + leftMargin,
      height,
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Application Date: ", padding + leftMargin, height);
    doc.setFont("helvetica", "normal");
    leftMargin = 150;
    // Get the current date
    var currentDate = new Date();
    var formattedDate =
      currentDate.getDate() +
      " " +
      [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ][currentDate.getMonth()] +
      " " +
      currentDate.getFullYear();
    doc.text(formattedDate, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Connection Type: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(connectionType, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Applied Load (kW): ", padding + leftMargin, height);
    leftMargin = 150;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applied_load.toString(), padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_name, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Mobile No.: ", padding + leftMargin, height);
    leftMargin = 150;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_phone_no, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant CNIC: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_cnic, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Email: ", padding + leftMargin, height);
    leftMargin = 150;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_email, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text(values.iv_relation_type + ": ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_relative_name, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Address: ", padding, height);
    doc.setFont("helvetica", "normal");
    let address = "";
    if (values.iv_area_type === "Urban" || values.iv_area_type === "urban") {
      address = values.iv_address + ", " + values.iv_city_district;
    }
    if (values.iv_area_type === "Rural" || values.iv_area_type === "rural") {
      address = values.iv_address.concat(
        ", " + values.iv_town_tehsil + " ," + values.iv_city_district,
      );
    }
    doc.text(address, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Issued By: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(userName + " (" + userId + ")", padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Designation: ", padding + leftMargin, height);
    leftMargin = 130;
    doc.setFont("helvetica", "normal");
    doc.text(userRole, padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      if (userCompany != 91) {
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight(),
        );
      }
    }

    const pdfBlob = doc.output("blob");
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfDataUrl, "_blank");
  };

  const handleClose = () => {
    setNewConnectionPopup(false);
    window.location.href = "new-connection-table";
  };

  const onLocationSelect = (loc) => {
    values.iv_location = loc;
  };

  const [nCStatusBarArray, setNCStatusBarArray] = useState([
    {
      title1: "APPLICATION",
      title2: "DETAIL",
      status: 0,
    },
    {
      title1: `APPLICANT's`,
      title2: "CNIC",
      status: 0,
    },
    {
      title1: "PROPERTY",
      title2: "DOCUMENT",
      status: 0,
    },
    {
      title1: "NEAR-BY",
      title2: "BILL",
      status: 0,
    },
    {
      title1: "TEST WIRING",
      title2: "REPORT",
      status: 0,
    },
    {
      title1: "ANY OTHER",
      title2: "DOCUMENT",
      status: 0,
    },
  ]);

  useEffect(() => {
    if (values.iv_connection_type !== "Industrial") {
      if (values.iv_connection_type !== "Commercial") {
        if (values.iv_applicant_status === "Owner") {
          if (
            values.iv_applicant_status &&
            values.iv_applicant_name &&
            values.iv_applicant_cnic &&
            values.iv_relation_type &&
            values.iv_relative_name &&
            values.iv_applicant_citizenship &&
            values.iv_applicant_phone_no &&
            values.iv_area_type &&
            ((values.iv_area_type === "Urban" && values.iv_address) ||
              (values.iv_area_type === "Rural" && values.iv_address)) &&
            (values.iv_area_type === "Urban" || values.iv_town_tehsil) &&
            values.iv_city_district &&
            (values.iv_meter_installed || values.iv_meter_installed == 0) &&
            values.iv_connection_type &&
            values.iv_applied_load &&
            values.iv_circle &&
            values.iv_division &&
            values.iv_sub_divison
          ) {
            setNCStatusBarArray((prevArray) => {
              const updatedArray = [...prevArray];
              updatedArray[0] = {
                ...updatedArray[0],
                status: 1, // Set the status to the desired value
              };
              return updatedArray;
            });
          } else {
            setNCStatusBarArray((prevArray) => {
              const updatedArray = [...prevArray];
              updatedArray[0] = {
                ...updatedArray[0],
                status: 0, // Set the status to the desired value
              };
              return updatedArray;
            });
          }
        } else if (values.iv_applicant_status === "Tenant") {
          if (
            values.iv_applicant_status &&
            values.iv_applicant_name &&
            values.iv_applicant_cnic &&
            values.iv_relation_type &&
            values.iv_relative_name &&
            values.iv_applicant_citizenship &&
            values.iv_applicant_phone_no &&
            values.iv_area_type &&
            ((values.iv_area_type === "Urban" && values.iv_address) ||
              (values.iv_area_type === "Rural" && values.iv_address)) &&
            (values.iv_area_type === "Urban" || values.iv_town_tehsil) &&
            values.iv_city_district &&
            (values.iv_meter_installed || values.iv_meter_installed == 0) &&
            values.iv_connection_type &&
            values.iv_applied_load &&
            values.iv_circle &&
            values.iv_division &&
            values.iv_sub_divison &&
            values.iv_owner_name &&
            values.iv_owner_cnic &&
            values.iv_owner_phone_no
          ) {
            setNCStatusBarArray((prevArray) => {
              const updatedArray = [...prevArray];
              updatedArray[0] = {
                ...updatedArray[0],
                status: 1, // Set the status to the desired value
              };
              return updatedArray;
            });
          } else {
            setNCStatusBarArray((prevArray) => {
              const updatedArray = [...prevArray];
              updatedArray[0] = {
                ...updatedArray[0],
                status: 0, // Set the status to the desired value
              };
              return updatedArray;
            });
          }
        }
      } else {
        if (values.iv_applicant_status === "Owner") {
          if (
            values.iv_applicant_status &&
            values.iv_applicant_name &&
            values.iv_applicant_cnic &&
            values.iv_relation_type &&
            values.iv_relative_name &&
            values.iv_applicant_citizenship &&
            values.iv_applicant_phone_no &&
            values.iv_area_type &&
            ((values.iv_area_type === "Urban" && values.iv_address) ||
              (values.iv_area_type === "Rural" && values.iv_address)) &&
            (values.iv_area_type === "Urban" || values.iv_town_tehsil) &&
            values.iv_city_district &&
            (values.iv_meter_installed || values.iv_meter_installed == 0) &&
            values.iv_connection_type &&
            values.iv_applied_load &&
            values.iv_circle &&
            values.iv_division &&
            values.iv_sub_divison &&
            values.iv_ntn &&
            values.iv_strn
          ) {
            setNCStatusBarArray((prevArray) => {
              const updatedArray = [...prevArray];
              updatedArray[0] = {
                ...updatedArray[0],
                status: 1, // Set the status to the desired value
              };
              return updatedArray;
            });
          } else {
            setNCStatusBarArray((prevArray) => {
              const updatedArray = [...prevArray];
              updatedArray[0] = {
                ...updatedArray[0],
                status: 0, // Set the status to the desired value
              };
              return updatedArray;
            });
          }
        } else if (values.iv_applicant_status === "Tenant") {
          if (
            values.iv_applicant_status &&
            values.iv_applicant_name &&
            values.iv_applicant_cnic &&
            values.iv_relation_type &&
            values.iv_relative_name &&
            values.iv_applicant_citizenship &&
            values.iv_applicant_phone_no &&
            values.iv_area_type &&
            ((values.iv_area_type === "Urban" && values.iv_address) ||
              (values.iv_area_type === "Rural" && values.iv_address)) &&
            (values.iv_area_type === "Urban" || values.iv_town_tehsil) &&
            values.iv_city_district &&
            (values.iv_meter_installed || values.iv_meter_installed == 0) &&
            values.iv_connection_type &&
            values.iv_applied_load &&
            values.iv_circle &&
            values.iv_division &&
            values.iv_sub_divison &&
            values.iv_owner_name &&
            values.iv_owner_cnic &&
            values.iv_owner_phone_no &&
            values.iv_ntn &&
            values.iv_strn
          ) {
            setNCStatusBarArray((prevArray) => {
              const updatedArray = [...prevArray];
              updatedArray[0] = {
                ...updatedArray[0],
                status: 1, // Set the status to the desired value
              };
              return updatedArray;
            });
          } else {
            setNCStatusBarArray((prevArray) => {
              const updatedArray = [...prevArray];
              updatedArray[0] = {
                ...updatedArray[0],
                status: 0, // Set the status to the desired value
              };
              return updatedArray;
            });
          }
        }
      }
    } else {
      if (values.iv_applicant_status === "Owner") {
        if (
          values.iv_applicant_status &&
          values.iv_applicant_name &&
          values.iv_applicant_cnic &&
          values.iv_relation_type &&
          values.iv_relative_name &&
          values.iv_applicant_citizenship &&
          values.iv_applicant_phone_no &&
          values.iv_area_type &&
          ((values.iv_area_type === "Urban" && values.iv_address) ||
            (values.iv_area_type === "Rural" && values.iv_address)) &&
          (values.iv_area_type === "Urban" || values.iv_town_tehsil) &&
          values.iv_city_district &&
          (values.iv_meter_installed || values.iv_meter_installed == 0) &&
          values.iv_connection_type &&
          values.iv_applied_load &&
          values.iv_circle &&
          values.iv_division &&
          values.iv_sub_divison &&
          values.iv_ntn &&
          values.iv_strn &&
          (values.iv_meter_seasonal || values.iv_meter_seasonal == 0)
        ) {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[0] = {
              ...updatedArray[0],
              status: 1, // Set the status to the desired value
            };
            return updatedArray;
          });
        } else {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[0] = {
              ...updatedArray[0],
              status: 0, // Set the status to the desired value
            };
            return updatedArray;
          });
        }
      } else if (values.iv_applicant_status === "Tenant") {
        if (
          values.iv_applicant_status &&
          values.iv_applicant_name &&
          values.iv_applicant_cnic &&
          values.iv_relation_type &&
          values.iv_relative_name &&
          values.iv_applicant_citizenship &&
          values.iv_applicant_phone_no &&
          values.iv_area_type &&
          ((values.iv_area_type === "Urban" && values.iv_address) ||
            (values.iv_area_type === "Rural" && values.iv_address)) &&
          (values.iv_area_type === "Urban" || values.iv_town_tehsil) &&
          values.iv_city_district &&
          (values.iv_meter_installed || values.iv_meter_installed == 0) &&
          values.iv_connection_type &&
          values.iv_applied_load &&
          values.iv_circle &&
          values.iv_division &&
          values.iv_sub_divison &&
          values.iv_owner_name &&
          values.iv_owner_cnic &&
          values.iv_owner_phone_no &&
          values.iv_ntn &&
          values.iv_strn &&
          (values.iv_meter_seasonal || values.iv_meter_seasonal == 0)
        ) {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[0] = {
              ...updatedArray[0],
              status: 1, // Set the status to the desired value
            };
            return updatedArray;
          });
        } else {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[0] = {
              ...updatedArray[0],
              status: 0, // Set the status to the desired value
            };
            return updatedArray;
          });
        }
      }
    }
  }, [values]);

  useEffect(() => {
    if (values.iv_connection_type && values.iv_applicant_status) {
      setNCStatusBarArray((prevArray) => {
        const newArray = [];

        if (values.iv_connection_type !== "Industrial") {
          if (values.iv_applicant_status === "Owner") {
            newArray.push(
              ...[
                {
                  title1: "APPLICATION",
                  title2: "DETAIL",
                  status: prevArray[0]?.status || 0,
                },
                {
                  title1: `APPLICANT'S`,
                  title2: "CNIC",
                  status: prevArray[1]?.status || 0,
                },
                {
                  title1: "PROPERTY",
                  title2: "DOCUMENT",
                  status: prevArray[2]?.status || 0,
                },
                {
                  title1: "NEAR-BY",
                  title2: "BILL",
                  status: prevArray[3]?.status || 0,
                },
                {
                  title1: "TEST WIRING",
                  title2: "REPORT",
                  status: prevArray[4]?.status || 0,
                },
                {
                  title1: "ANY OTHER",
                  title2: "DOCUMENT",
                  status: prevArray[5]?.status || 0,
                },
              ],
            );
          } else {
            newArray.push(
              ...[
                {
                  title1: "APPLICATION",
                  title2: "DETAIL",
                  status: prevArray[0]?.status || 0,
                },
                {
                  title1: `APPLICANT'S`,
                  title2: "CNIC",
                  status: prevArray[1]?.status || 0,
                },
                {
                  title1: "PROPERTY",
                  title2: "DOCUMENT",
                  status: prevArray[2]?.status || 0,
                },
                {
                  title1: "NEAR-BY",
                  title2: "BILL",
                  status: prevArray[3]?.status || 0,
                },
                {
                  title1: "TEST WIRING",
                  title2: "REPORT",
                  status: prevArray[4]?.status || 0,
                },
                {
                  title1: "ANY OTHER",
                  title2: "DOCUMENT",
                  status: prevArray[5]?.status || 0,
                },
                {
                  title1: `OWNER'S`,
                  title2: "CNIC",
                  status: prevArray[6]?.status || 0,
                },
                {
                  title1: "NOC FROM",
                  title2: "OWNER",
                  status: prevArray[7]?.status || 0,
                },
              ],
            );
          }
        } else {
          if (values.iv_applicant_status === "Owner") {
            newArray.push(
              ...[
                {
                  title1: "APPLICATION",
                  title2: "DETAIL",
                  status: prevArray[0]?.status || 0,
                },
                {
                  title1: `APPLICANT'S`,
                  title2: "CNIC.",
                  status: prevArray[1]?.status || 0,
                },
                {
                  title1: "PROPERTY",
                  title2: "DOCUMENT",
                  status: prevArray[2]?.status || 0,
                },
                {
                  title1: "NEAR-BY",
                  title2: "BILL",
                  status: prevArray[3]?.status || 0,
                },
                {
                  title1: "TEST WIRING",
                  title2: "REPORT",
                  status: prevArray[4]?.status || 0,
                },
                {
                  title1: "ANY OTHER",
                  title2: "DOCUMENT",
                  status: prevArray[5]?.status || 0,
                },
                {
                  title1: `BOD'S`,
                  title2: "FORM",
                  status: prevArray[6]?.status || 0,
                },
                {
                  title1: "MOA",
                  title2: "",
                  status: prevArray[7]?.status || 0,
                },
                {
                  title1: "FORM-29",
                  title2: "",
                  status: prevArray[8]?.status || 0,
                },
              ],
            );
          } else {
            newArray.push(
              ...[
                {
                  title1: "APPLICATION",
                  title2: "DETAIL",
                  status: prevArray[0]?.status || 0,
                },
                {
                  title1: `APPLICANT'S`,
                  title2: "CNIC",
                  status: prevArray[1]?.status || 0,
                },
                {
                  title1: "PROPERTY",
                  title2: "DOCUMENT",
                  status: prevArray[2]?.status || 0,
                },
                {
                  title1: "NEAR-BY",
                  title2: "BILL",
                  status: prevArray[3]?.status || 0,
                },
                {
                  title1: "TEST WIRING",
                  title2: "REPORT",
                  status: prevArray[4]?.status || 0,
                },
                {
                  title1: "ANY OTHER",
                  title2: "DOCUMENT",
                  status: prevArray[5]?.status || 0,
                },
                {
                  title1: `OWNER'S`,
                  title2: "CNIC",
                  status: prevArray[6]?.status || 0,
                },
                {
                  title1: "NOC FROM",
                  title2: "OWNER",
                  status: prevArray[7]?.status || 0,
                },
                {
                  title1: `BOD'S`,
                  title2: "FORM",
                  status: prevArray[8]?.status || 0,
                },
                {
                  title1: "MOA",
                  title2: " ",
                  status: prevArray[9]?.status || 0,
                },
                {
                  title1: "FORM-29",
                  title2: "",
                  status: prevArray[10]?.status || 0,
                },
              ],
            );
          }
        }

        return newArray;
      });
    }
  }, [values.iv_connection_type, values.iv_applicant_status]);

  useEffect(() => {
    if (values.iv_meter_seasonal || values.iv_meter_seasonal == "0") {
      if (
        values.iv_connection_type === "Industrial" &&
        values.iv_meter_seasonal == "1"
      ) {
        const seasonalTariff = tariffs.data.find(
          (item) => item.tariffCode === "F",
        );

        // Check if seasonalTariff is found before setting the state
        if (seasonalTariff) {
          setTariff(seasonalTariff.tariffName || "");
        } else {
          // Handle the case when the seasonal tariff is not found
          setTariff("");
        }
      } else {
        setTariff("");
      }
    }
  }, [values.iv_meter_seasonal]);

  useEffect(() => {
    if (applicantCnicDocumentFront && applicantCnicDocumentBack) {
      setNCStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 1, // Set the status to the desired value
        };
        return updatedArray;
      });
    } else {
      setNCStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 0, // Set the status to the desired value
        };
        return updatedArray;
      });
    }
  }, [applicantCnicDocumentFront, applicantCnicDocumentBack]);

  useEffect(() => {
    if (propertyDocuments) {
      setNCStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[2] = {
          ...updatedArray[2],
          status: 1, // Set the status to the desired value
        };
        return updatedArray;
      });
    } else {
      setNCStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[2] = {
          ...updatedArray[2],
          status: 0, // Set the status to the desired value
        };
        return updatedArray;
      });
    }
  }, [propertyDocuments]);

  useEffect(() => {
    if (nearByBillDocument) {
      setNCStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[3] = {
          ...updatedArray[3],
          status: 1, // Set the status to the desired value
        };
        return updatedArray;
      });
    } else {
      setNCStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[3] = {
          ...updatedArray[3],
          status: 0, // Set the status to the desired value
        };
        return updatedArray;
      });
    }
  }, [nearByBillDocument]);

  useEffect(() => {
    if (testWiringReportDocument) {
      setNCStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[4] = {
          ...updatedArray[4],
          status: 1, // Set the status to the desired value
        };
        return updatedArray;
      });
    } else {
      setNCStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[4] = {
          ...updatedArray[4],
          status: 0, // Set the status to the desired value
        };
        return updatedArray;
      });
    }
  }, [testWiringReportDocument]);

  useEffect(() => {
    if (anyOtherDocument) {
      setNCStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[5] = {
          ...updatedArray[5],
          status: 1, // Set the status to the desired value
        };
        return updatedArray;
      });
    } else {
      setNCStatusBarArray((prevArray) => {
        const updatedArray = [...prevArray];
        updatedArray[5] = {
          ...updatedArray[5],
          status: 0, // Set the status to the desired value
        };
        return updatedArray;
      });
    }
  }, [anyOtherDocument]);

  useEffect(() => {
    if (values.iv_applicant_status == "Tenant") {
      if (ownerCnicDocumentFront && ownerCnicDocumentBack) {
        setNCStatusBarArray((prevArray) => {
          const updatedArray = [...prevArray];
          updatedArray[6] = {
            ...updatedArray[6],
            status: 1, // Set the status to the desired value
          };
          return updatedArray;
        });
      } else {
        setNCStatusBarArray((prevArray) => {
          const updatedArray = [...prevArray];
          updatedArray[6] = {
            ...updatedArray[6],
            status: 0, // Set the status to the desired value
          };
          return updatedArray;
        });
      }
    }
  }, [
    ownerCnicDocumentFront,
    ownerCnicDocumentBack,
    values.iv_applicant_status,
  ]);

  useEffect(() => {
    if (values.iv_applicant_status === "Tenant") {
      if (nocOwnerDocument) {
        setNCStatusBarArray((prevArray) => {
          const updatedArray = [...prevArray];
          updatedArray[7] = {
            ...updatedArray[7],
            status: 1, // Set the status to the desired value
          };
          return updatedArray;
        });
      } else {
        setNCStatusBarArray((prevArray) => {
          const updatedArray = [...prevArray];
          updatedArray[7] = {
            ...updatedArray[7],
            status: 0, // Set the status to the desired value
          };
          return updatedArray;
        });
      }
    }
  }, [nocOwnerDocument, values.iv_applicant_status]);

  useEffect(() => {
    if (values.iv_connection_type === "Industrial") {
      if (values.iv_applicant_status === "Owner") {
        if (resolutionDocument) {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[6] = {
              ...updatedArray[6],
              status: 1, // Set the status to the desired value
            };
            return updatedArray;
          });
        } else {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[6] = {
              ...updatedArray[6],
              status: 0, // Set the status to the desired value
            };
            return updatedArray;
          });
        }
      } else {
        if (resolutionDocument) {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[8] = {
              ...updatedArray[8],
              status: 1, // Set the status to the desired value
            };
            return updatedArray;
          });
        } else {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[8] = {
              ...updatedArray[8],
              status: 0, // Set the status to the desired value
            };
            return updatedArray;
          });
        }
      }
    }
  }, [resolutionDocument, values.iv_applicant_status]);

  useEffect(() => {
    if (values.iv_connection_type === "Industrial") {
      if (values.iv_applicant_status === "Owner") {
        if (memorandumDocument) {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[7] = {
              ...updatedArray[7],
              status: 1, // Set the status to the desired value
            };
            return updatedArray;
          });
        } else {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[7] = {
              ...updatedArray[7],
              status: 0, // Set the status to the desired value
            };
            return updatedArray;
          });
        }
      } else {
        if (resolutionDocument) {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[9] = {
              ...updatedArray[9],
              status: 1, // Set the status to the desired value
            };
            return updatedArray;
          });
        } else {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[9] = {
              ...updatedArray[9],
              status: 0, // Set the status to the desired value
            };
            return updatedArray;
          });
        }
      }
    }
  }, [memorandumDocument, values.iv_applicant_status]);

  useEffect(() => {
    if (values.iv_connection_type === "Industrial") {
      if (values.iv_applicant_status === "Owner") {
        if (form29Document) {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[8] = {
              ...updatedArray[8],
              status: 1, // Set the status to the desired value
            };
            return updatedArray;
          });
        } else {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[8] = {
              ...updatedArray[8],
              status: 0, // Set the status to the desired value
            };
            return updatedArray;
          });
        }
      } else {
        if (resolutionDocument) {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[10] = {
              ...updatedArray[10],
              status: 1, // Set the status to the desired value
            };
            return updatedArray;
          });
        } else {
          setNCStatusBarArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[10] = {
              ...updatedArray[10],
              status: 0, // Set the status to the desired value
            };
            return updatedArray;
          });
        }
      }
    }
  }, [form29Document, values.iv_applicant_status]);

  const isUrbanAreaValid =
    values.iv_area_type === "Urban" && values.iv_address !== "";

  const isRuralAreaValid =
    values.iv_area_type === "Rural" && values.iv_address !== "";

  const isAreaValid = isUrbanAreaValid || isRuralAreaValid;

  const isTestWiringOptional =
    values.iv_connection_type === "Temporary" ||
    values.iv_connection_type === "Electrification";

  const commonFieldsValid =
    values.iv_applied_load !== "" &&
    values.iv_circle !== "" &&
    values.iv_division !== "" &&
    values.iv_sub_divison !== "" &&
    values.iv_applicant_name !== "" &&
    values.iv_applicant_cnic !== "" &&
    values.iv_applicant_phone_no !== "" &&
    isAreaValid &&
    (values.iv_area_type === "Urban" || values.iv_town_tehsil !== "") &&
    values.iv_city_district !== "" &&
    values.iv_city_district != null &&
    applicantCnicDocumentFront &&
    applicantCnicDocumentBack &&
    nearByBillDocument &&
    propertyDocuments &&
    (isTestWiringOptional || testWiringReportDocument);

  const ownerFieldsValid =
    values.iv_owner_name !== "" &&
    values.iv_owner_cnic !== "" &&
    values.iv_owner_phone_no !== "" &&
    ownerCnicDocumentFront &&
    ownerCnicDocumentBack &&
    nocOwnerDocument;

  const industrialFieldsValid =
    values.iv_meter_seasonal !== "" &&
    values.iv_ntn !== "" &&
    values.iv_strn !== "" &&
    resolutionDocument &&
    form29Document;

  const commercialFieldsValid = values.iv_ntn !== "" && values.iv_strn !== "";

  const isDisabled =
    values.iv_connection_type === "Industrial"
      ? values.iv_applicant_status === "Owner"
        ? !(commonFieldsValid && industrialFieldsValid)
        : !(commonFieldsValid && industrialFieldsValid && ownerFieldsValid)
      : values.iv_connection_type === "Commercial"
        ? values.iv_applicant_status === "Owner"
          ? !(commonFieldsValid && commercialFieldsValid)
          : !(commonFieldsValid && commercialFieldsValid && ownerFieldsValid)
        : isStandardConnectionType(
              values.iv_connection_type,
              connectionTypesList,
            )
          ? values.iv_applicant_status === "Owner"
            ? !commonFieldsValid
            : !(commonFieldsValid && ownerFieldsValid)
          : true;

  return (
    <>
      {/* Main Form code */}
      <Grid container className="nc-page" sx={{ width: '100%', maxWidth: '100%' }}>
        <Box className="nc-container" sx={{ width: '100%', maxWidth: '100%' }}>
          <h3 className="heading nc-page-title">New Connection Application</h3>
          <div
            className={`nc-stepper-wrap${
              nCStatusBarArray.length > 6 ? ' nc-stepper-wrap--many' : ''
            }`}
          >
            <StepProgressBar array={nCStatusBarArray} pageName="NC Form" />
          </div>
          <form onSubmit={handleSubmit} noValidate className="nc-form">
            <div className="section-card section-card--accent">
              <div className="section-title">Applicant&apos;s Details</div>
            <Grid container spacing={1} className="container nc-applicant-fields">
              <Grid container item xs={12} spacing={1} className="nc-form-row">
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                <Typography className="fieldLabel">Type</Typography>
                <Select
                  fullWidth
                  autoWidth={false}
                  autoFocus
                  value={values.iv_connection_type}
                  onChange={ConnectionType}
                  onBlur={handleBlur}
                  displayEmpty
                  className="connectionTypeDropDownList"
                  name="iv_connection_type"
                  id="iv_connection_type"
                >
                  <MenuItem value="">Select Type</MenuItem>
                  {connectionTypesList.map((type) => (
                    <MenuItem
                      key={type.connectionTypeId}
                      value={type.connectionTypeName}
                    >
                      {type.connectionTypeName === "Domestic"
                        ? "Residential"
                        : type.connectionTypeName}
                    </MenuItem>
                  ))}
                </Select>
                <Box className="from-Error">
                  {errors.iv_connection_type && touched.iv_connection_type
                    ? errors.iv_connection_type
                    : null}
                </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <div className="field-wrap">
                <Typography className="fieldLabel">Name</Typography>
                <TextField
                  fullWidth
                  required
                  type="text"
                  name="iv_applicant_name"
                  value={values.iv_applicant_name}
                  autoComplete="off"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_applicant_name"
                  className="textInputField"
                />
                <Box className="from-Error">
                  {errors.iv_applicant_name && touched.iv_applicant_name
                    ? errors.iv_applicant_name
                    : null}
                </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                <Typography className="fieldLabel">
                  NIC. / CNIC. / NICOP.
                </Typography>
                <TextField
                  required
                  type="text"
                  name="iv_applicant_cnic"
                  value={values.iv_applicant_cnic}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_applicant_cnic"
                  className="textInputField"
                  inputProps={{ maxLength: 13, autoComplete: "off" }}
                />
                <Box className="from-Error">
                  {errors.iv_applicant_cnic && touched.iv_applicant_cnic
                    ? errors.iv_applicant_cnic
                    : null}
                </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                <Typography className="fieldLabel">
                  Relation Type
                </Typography>
                <FormControl className="form-control">
                  
                  <Select
                    fullWidth
                    displayEmpty
                    labelId="relation-type-label"
                    id="iv_relation_type"
                    name="iv_relation_type"
                    value={values.iv_relation_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="nc-select-field"
                  >
                    <MenuItem value="">
                      <em>Select Relation</em>
                    </MenuItem>
                    <MenuItem value="S/O" style={{ fontSize: "14px" }}>
                      S/O
                    </MenuItem>
                    <MenuItem value="D/O" style={{ fontSize: "14px" }}>
                      D/O
                    </MenuItem>
                    <MenuItem value="W/O" style={{ fontSize: "14px" }}>
                      W/O
                    </MenuItem>
                    <MenuItem value="C/O" style={{ fontSize: "14px" }}>
                      C/O
                    </MenuItem>
                  </Select>
                </FormControl>
                <Box className="from-Error">
                  {errors.iv_relation_type && touched.iv_relation_type
                    ? errors.iv_relation_type
                    : null}
                </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <div className="field-wrap">
                <Typography className="fieldLabel">
                  {values.iv_relation_type === "S/O" ||
                  values.iv_relation_type === "D/O"
                    ? `Father's `
                    : values.iv_relation_type === "W/O"
                      ? `Husband's `
                      : "Care of "}
                  Name
                </Typography>
                <TextField
                  required
                  type="text"
                  name="iv_relative_name"
                  value={values.iv_relative_name}
                  autoComplete="off"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_relative_name"
                  className="textInputField"
                />
                <Box className="from-Error">
                  {errors.iv_relative_name && touched.iv_relative_name
                    ? errors.iv_relative_name
                    : null}
                </Box>
                </div>
              </Grid>
              </Grid>

              <Grid container item xs={12} spacing={1} className="nc-form-row">
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                <Typography className="fieldLabel">Status</Typography>
                <FormControl className="form-control">
                  <RadioGroup
                    className="radio-group"
                    row
                    name="iv_applicant_status"
                    defaultValue={values.iv_applicant_status}
                    value={values.iv_applicant_status}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Owner"
                      className="form-control-label"
                      control={<Radio />}
                      sx={{
                        ".MuiFormControlLabel-label": { fontSize: "14px" },
                      }}
                      label="Owner"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="Tenant"
                      className="form-control-label"
                      control={<Radio />}
                      sx={{
                        ".MuiFormControlLabel-label": { fontSize: "14px" },
                      }}
                      label="Tenant"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
                <Box className="from-Error">
                  {errors.iv_applicant_status && touched.iv_applicant_status
                    ? errors.iv_applicant_status
                    : null}
                </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={connectionType === "Industrial" || connectionType === "Commercial" || connectionType === "Corporate Company" ? 2 : 3}>
                <div className="field-wrap">
                <Typography className="fieldLabel">Citizenship</Typography>
                <FormControl className="form-control">
                  <RadioGroup
                    className="radio-group"
                    row
                    name="iv_applicant_citizenship"
                    defaultValue={values.iv_applicant_citizenship}
                    value={values.iv_applicant_citizenship}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Pakistani"
                      className="form-control-label"
                      control={<Radio size="small" />}
                      label="Pakistani"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="Foreigner"
                      className="form-control-label"
                      control={<Radio size="small" />}
                      label="Foreigner"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
                <Box className="from-Error">
                  {errors.iv_applicant_citizenship &&
                  touched.iv_applicant_citizenship
                    ? errors.iv_applicant_citizenship
                    : null}
                </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={connectionType === "Industrial" || connectionType === "Commercial" || connectionType === "Corporate Company" ? 2 : 3}>
                <div className="field-wrap">
                <Typography className="fieldLabel">Mobile No.</Typography>
                <TextField
                  required
                  type="text"
                  name="iv_applicant_phone_no"
                  autoComplete="off"
                  value={values.iv_applicant_phone_no}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  inputProps={{ maxLength: 11 }}
                  id="iv_applicant_phone_no"
                  className="textInputField"
                />
                <Box className="from-Error">
                  {errors.iv_applicant_phone_no && touched.iv_applicant_phone_no
                    ? errors.iv_applicant_phone_no
                    : null}
                </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={connectionType === "Industrial" || connectionType === "Commercial" || connectionType === "Corporate Company" ? 2 : 4}>
                <div className="field-wrap">
                <Typography className="fieldLabel">
                  Email<span style={{ color: "#A1A1A1" }}> (Optional)</span>
                </Typography>
                <TextField
                  autoComplete="off"
                  required
                  type="text"
                  name="iv_applicant_email"
                  value={values.iv_applicant_email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_applicant_email"
                  className="textInputField"
                />
                <Box className="from-Error">
                  {errors.iv_applicant_email && touched.iv_applicant_email
                    ? errors.iv_applicant_email
                    : null}
                </Box>
                </div>
              </Grid>
              {connectionType === "Industrial" ||
              connectionType === "Commercial" ||
              connectionType === "Corporate Company" ? (
                <>
                  <Grid item xs={12} sm={6} md={2}>
                    <div className="field-wrap">
                    <Typography className="fieldLabel">NTN.</Typography>
                    <TextField
                      autoComplete="off"
                      required
                      type="text"
                      name="iv_ntn"
                      value={values.iv_ntn}
                      onChange={(event) =>
                        handleNumericChange(event, "iv_ntn", 13)
                      }
                      onBlur={handleBlur}
                      inputProps={{ maxLength: 13, inputMode: "numeric" }}
                      label=""
                      id="iv_ntn"
                      className="textInputField"
                    />
                    <Box className="from-Error">
                      {errors.iv_ntn && touched.iv_ntn ? errors.iv_ntn : null}
                    </Box>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <div className="field-wrap">
                    <Typography className="fieldLabel">STRN.</Typography>
                    <TextField
                      required
                      autoComplete="off"
                      type="text"
                      name="iv_strn"
                      value={values.iv_strn}
                      inputProps={{ maxLength: 13, inputMode: "numeric" }}
                      onChange={(event) =>
                        handleNumericChange(event, "iv_strn", 13)
                      }
                      onBlur={handleBlur}
                      id="iv_strn"
                      className="textInputField"
                    />
                    <Box className="from-Error">
                      {errors.iv_strn && touched.iv_strn
                        ? errors.iv_strn
                        : null}
                    </Box>
                    </div>
                  </Grid>
                </>
              ) : null}
              </Grid>

              <Grid container item xs={12} spacing={1} className="nc-form-row">
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                <Typography className="fieldLabel">Area Type</Typography>
                <FormControl className="form-control">
                  <RadioGroup
                    className="radio-group"
                    row
                    name="iv_area_type"
                    defaultValue={values.iv_area_type}
                    value={values.iv_area_type}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Urban"
                      className="form-control-label"
                      sx={{
                        ".MuiFormControlLabel-label": { fontSize: "14px" },
                      }}
                      control={<Radio />}
                      label="Urban"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="Rural"
                      className="form-control-label"
                      control={<Radio />}
                      sx={{
                        ".MuiFormControlLabel-label": { fontSize: "14px" },
                      }}
                      label="Rural"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
                <Box className="from-Error">
                  {errors.iv_area_type && touched.iv_area_type
                    ? errors.iv_area_type
                    : null}
                </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={values.iv_area_type !== "Urban" ? 4 : 5}>
                <div className="field-wrap">
                <Typography className="fieldLabel">
                  Address (
                  <span style={{ fontWeight: 500 }}>
                    Where Meter is to be installed
                  </span>
                  ).
                </Typography>

                <TextField
                  required
                  type="text"
                  inputProps={{
                    maxLength: values.iv_area_type == "Urban" ? 40 : 30,
                  }}
                  name="iv_address"
                  autoComplete="off"
                  value={values.iv_address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_address"
                  className="textInputField"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        sx={{ fontSize: "12px", color: "blue" }}
                        style={{ background: "#F2F4F6" }}
                      >
                        Max {values.iv_area_type === "Urban" ? 40 : 30} chars.
                      </InputAdornment>
                    ),
                  }}
                />
                <Box className="from-Error">
                  {errors.iv_address && touched.iv_address
                    ? errors.iv_address
                    : null}
                </Box>
                </div>
              </Grid>
              
              {values.iv_area_type !== "Urban" ? (
                <Grid item xs={12} sm={6} md={2}>
                  <div className="field-wrap">
                  <Typography className="fieldLabel">Tehsil</Typography>
                  <TextField
                    required
                    autoComplete="off"
                    type="text"
                    inputProps={{ maxLength: 15 }}
                    name="iv_town_tehsil"
                    value={values.iv_town_tehsil}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="iv_town_tehsil"
                    className="textInputField"
                  />
                  <Box className="from-Error">
                    {errors.iv_town_tehsil && touched.iv_town_tehsil
                      ? errors.iv_town_tehsil
                      : null}
                  </Box>
                  </div>
                </Grid>
              ) : null}
              <Grid item xs={12} sm={6} md={values.iv_area_type !== "Urban" ? 2 : 3}>
                <div className="field-wrap">
                <Typography className="fieldLabel">District / City</Typography>
                <Autocomplete
                  id="iv_city_district"
                  name="iv_city_district"
                  autoComplete="off"
                  options={cities ? cities : []}
                  value={values.iv_city_district}
                  filterOptions={filterOptions}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      handleChange("iv_city_district")(newValue);
                    }
                  }}
                  onBlur={handleBlur}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      type="text"
                      className="textInputFieldAutoSelect"
                    />
                  )}
                />
                <Box className="from-Error">
                  {errors.iv_city_district && touched.iv_city_district
                    ? errors.iv_city_district
                    : null}
                </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                <Typography className="fieldLabel">
                  Already installed meters
                </Typography>
                <TextField
                  required
                  autoComplete="off"
                  type="number"
                  InputProps={{
                    inputProps: { min: 0, step: 1, pattern: "[0-9]*" },
                  }}
                  name="iv_meter_installed"
                  value={values.iv_meter_installed}
                  onChange={(e) => {
                    const rawValue = e.target.value;
                    if (rawValue === "") {
                      handleChange(e);
                      return;
                    }

                    // Allow only non-negative whole numbers at input time
                    if (!/^\d+$/.test(rawValue)) {
                      return;
                    }

                    handleChange(e);
                  }}
                  onKeyDown={(e) => {
                    if ([".", ",", "e", "E", "-", "+"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onBlur={handleBlur}
                  id="iv_meter_installed"
                  className="textInputField"
                />
                <Box className="from-Error">
                  {errors.iv_meter_installed && touched.iv_meter_installed
                    ? errors.iv_meter_installed
                    : null}
                </Box>
                </div>
              </Grid>
              </Grid>
            </Grid>
            </div>
            {values.iv_applicant_status === "Tenant" ? (
              <>
                <div className="section-card section-card--owner">
                <div className="section-title">Owner&apos;s Details</div>
                <Grid container spacing={1} className="container">
                  <Grid container item xs={12} spacing={1} className="nc-form-row">
                  <Grid item xs={12} sm={6} md={4}>
                    <div className="field-wrap">
                    <Typography className="fieldLabel">Name</Typography>
                    <TextField
                      required
                      type="text"
                      autoComplete="off"
                      name="iv_owner_name"
                      value={values.iv_owner_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="iv_owner_name"
                      className="textInputField"
                    />
                    <Box className="from-Error">
                      {errors.iv_owner_name && touched.iv_owner_name
                        ? errors.iv_owner_name
                        : null}
                    </Box>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <div className="field-wrap">
                    <Typography className="fieldLabel">
                      NIC. / CNIC. / NICOP.
                    </Typography>
                    <TextField
                      required
                      type="double"
                      autoComplete="off"
                      value={values.iv_owner_cnic}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      inputProps={{ maxLength: 13 }}
                      name="iv_owner_cnic"
                      id="iv_owner_cnic"
                      className="textInputField"
                    />
                    <Box className="from-Error">
                      {errors.iv_owner_cnic && touched.iv_owner_cnic
                        ? errors.iv_owner_cnic
                        : null}
                    </Box>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <div className="field-wrap">
                    <Typography className="fieldLabel">Mobile No.</Typography>
                    <TextField
                      required
                      type="text"
                      autoComplete="off"
                      inputProps={{ maxLength: 11 }}
                      name="iv_owner_phone_no"
                      value={values.iv_owner_phone_no}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="iv_owner_phone_no"
                      className="textInputField"
                    />
                    <Box className="from-Error">
                      {errors.iv_owner_phone_no && touched.iv_owner_phone_no
                        ? errors.iv_owner_phone_no
                        : null}
                    </Box>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <div className="field-wrap">
                    <Typography className="fieldLabel">
                      Email<span style={{ color: "#A1A1A1" }}> (Optional)</span>
                    </Typography>
                    <TextField
                      required
                      type="text"
                      value={values.iv_owner_email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      name="iv_owner_email"
                      id="iv_owner_email"
                      className="textInputField"
                    />
                    <Box className="from-Error">
                      {errors.iv_owner_email && touched.iv_owner_email
                        ? errors.iv_owner_email
                        : null}
                    </Box>
                    </div>
                  </Grid>
                  </Grid>
                </Grid>
                </div>
              </>
            ) : null}
            <div className="section-card section-card--connection">
            <div className="section-title">Connection Details</div>
            <Grid container spacing={1} className="container nc-connection-fields">
              <Grid container item xs={12} spacing={1} className="nc-form-row">
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                    <Typography className="fieldLabel">Load (kW)</Typography>
                    {showTooltip && (
                      <div className="tooltip">
                        {values.iv_connection_type === "Domestic" &&
                          "Residential Maximum Load 1000kW."}
                        {values.iv_connection_type === "Commercial" &&
                          "Commercial Maximum Load 5000kW."}
                      </div>
                    )}
                    <TextField
                      fullWidth
                      type="number"
                      name="iv_applied_load"
                      value={values.iv_applied_load}
                      onChange={handleLoadChange}
                      onFocus={handleFocus}
                      onBlur={(e) => {
                        setShowTooltip(false);
                        handleBlur(e);
                      }}
                      inputProps={{ min: 0.1, step: 0.1 }}
                      className="textInputField"
                    />
                    <Box className="from-Error-load">
                      {errors.iv_applied_load && touched.iv_applied_load
                        ? errors.iv_applied_load
                        : null}
                    </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                    <Typography className="fieldLabel">Meter Type</Typography>
                    <TextField
                      fullWidth
                      type="text"
                      disabled
                      name="iv_phase"
                      value={phase}
                      id="iv_phase"
                      className="textInputField1"
                    />
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                <Typography className="fieldLabel">
                  Near-by Reference No.
                  
                </Typography>
                <TextField
                  type="text"
                  name="iv_near_by_reference_no"
                  autoComplete="off"
                  value={values.iv_near_by_reference_no}
                  onChange={NearByReferenceNumber}
                  onBlur={handleBlur}
                  inputProps={{ maxLength: 14 }}
                  id="iv_near_by_reference_no"
                  className="textInputField"
                />
                <Box className="from-Error">
                  {errors.iv_near_by_reference_no &&
                  touched.iv_near_by_reference_no
                    ? errors.iv_near_by_reference_no
                    : null}
                </Box>

                <Box className="from-Error">
                  {referenceNumberError ? referenceNumberError : null}
                </Box>
                </div>
              </Grid>
              {isDiscoAdmin && (
                <Grid item xs={12} sm={6} md={2}>
                  <div className="field-wrap">
                    <Typography className="fieldLabel">Company</Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={selectedCompanyCode || ""}
                        onChange={handleCompanyChange}
                        displayEmpty
                        className="textInputField"
                      >
                        <MenuItem value="" disabled>
                          Select Company
                        </MenuItem>
                        <MenuItem value="11">LESCO</MenuItem>
                        <MenuItem value="12">GEPCO</MenuItem>
                        <MenuItem value="13">FESCO</MenuItem>
                        <MenuItem value="14">IESCO</MenuItem>
                        <MenuItem value="15">MEPCO</MenuItem>
                        <MenuItem value="26">PESCO</MenuItem>
                        <MenuItem value="27">HAZECO</MenuItem>
                        <MenuItem value="37">HESCO</MenuItem>
                        <MenuItem value="38">SEPCO</MenuItem>
                        <MenuItem value="48">QESCO</MenuItem>
                        <MenuItem value="59">TESCO</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                <Typography className="fieldLabel">Circle</Typography>
                <Autocomplete
                  id="iv_circle"
                  name="iv_circle"
                  value={defaultCircle ? defaultCircle : null}
                  options={circleList}
                  suppressDefaultValueWarning
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      className="textInputFieldAutoSelect"
                    />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      setDefaultCircle(value);
                      values.iv_circle = value.code;
                      setDefaultDivision();
                      setSubDivision();
                    }
                  }}
                />
                <Box className="from-Error">
                  {errors.iv_circle && touched.iv_circle
                    ? errors.iv_circle
                    : null}
                </Box>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <div className="field-wrap">
                <Typography className="fieldLabel">Division</Typography>
                <Autocomplete
                  id="iv_division"
                  name="iv_division"
                  options={divisionList}
                  value={defaultDivision ? defaultDivision : null}
                  suppressDefaultValueWarning
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      className="textInputFieldAutoSelect"
                    />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      setDefaultDivision(value);
                      values.iv_division = value.code;
                      setSubDivision();
                    }
                  }}
                />
                <Box className="from-Error">
                  {errors.iv_division && touched.iv_division
                    ? errors.iv_division
                    : null}
                </Box>
                </div>
              </Grid>
              </Grid>

              <Grid container item xs={12} spacing={1} className="nc-form-row">
              <Grid item xs={12} sm={6} md={2}>
                  <div className="field-wrap">
                    <Typography className="fieldLabel">Sub Division</Typography>
                    <Autocomplete
                      id="iv_sub_divison"
                      value={subDivision ? subDivision : null}
                      name="iv_sub_divison"
                      options={subDivisionList}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          className="textInputFieldAutoSelect"
                        />
                      )}
                      onChange={(event, value) => {
                        if (value) {
                          setSubDivision(value);
                          values.iv_sub_divison = value.code;
                        }
                      }}
                    />
                    <Box className="from-Error">
                      {errors.iv_sub_divison && touched.iv_sub_divison
                        ? errors.iv_sub_divison
                        : null}
                    </Box>
                  </div>
                </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <div className="field-wrap">
                <Typography className="fieldLabelNameAndAddressing">
                  Near-by Name
                </Typography>
                <TextField
                  name="iv_near_by_name"
                  required
                  type="text"
                  onBlur={handleBlur}
                  value={values.iv_near_by_name}
                  disabled
                  className="textInputFieldName"
                />
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={connectionType === "Industrial" ? 4 : 7}
              >
                <div className="field-wrap">
                <Typography className="fieldLabelNameAndAddressing">
                  Near-by Address
                </Typography>
                <TextField
                  required
                  name="iv_near_by_address"
                  type="text"
                  onBlur={handleBlur}
                  value={values.iv_near_by_address}
                  disabled
                  className="textInputFieldAddressing"
                />
                </div>
              </Grid>
              {connectionType === "Industrial" && (
                <Grid item xs={12} sm={6} md={3}>
                  <div className="field-wrap">
                  <Typography className="fieldLabel">Meter Season</Typography>
                  <FormControl className="form-control">
                    <RadioGroup
                      className="radio-group"
                      row
                      name="iv_meter_seasonal"
                      defaultValue={values.iv_meter_seasonal}
                      value={values.iv_meter_seasonal}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value={0}
                        className="form-control-label"
                        control={<Radio size="small" />}
                        label="Non-Seasonal"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value={1}
                        className="form-control-label"
                        control={<Radio size="small" />}
                        label="Seasonal"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Box className="from-Error">
                    {errors.iv_meter_seasonal && touched.iv_meter_seasonal
                      ? errors.iv_meter_seasonal
                      : null}
                  </Box>
                  </div>
                </Grid>
              )}
              </Grid>
            </Grid>
            </div>
            <div className="section-card section-card--docs">
            <div className="nc-docs-header">
              <div className="section-title">Required Documents</div>
              {(userCode.slice(0, 2) == "14" ||
                userCode.slice(0, 2) == "10") && (
                <Button
                  variant="outlined"
                  size="small"
                  className="nc-affidavit-btn"
                  onClick={() => window.open(affidavitImage, "_blank")}
                >
                  Download Affidavit
                </Button>
              )}
            </div>
            <Grid container spacing={2} className="documentsContainer documents-grid">
              <Grid item xs={12} sm={6} md={4} lg={4} className="nc-doc-col">
                <div className="nc-doc-col-head">
                <Typography className="documentLabel doc-grid-label">
                  1- Applicant&apos;s CNIC.
                </Typography>
                <Box className="documentError">
                  {errors.iv_applicant_cnic_document_front &&
                  touched.iv_applicant_cnic_document_front
                    ? errors.iv_applicant_cnic_document_front
                    : null}
                </Box>
                <Box className="documentError">
                  {errors.iv_applicant_cnic_document_back &&
                  touched.iv_applicant_cnic_document_back
                    ? errors.iv_applicant_cnic_document_back
                    : null}
                </Box>
                </div>
                <div className="doc-grid-uploads cnic-upload-pair">
                <div className="upload-wrap">
                {applicantCnicDocumentFront ? (
                  <>
                    <Button
                      component="label"
                      className="upload-preview"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setApplicantCnicDocumentFront("");
                          }}
                        />
                      }
                    >
                      {applicantCnicDocumentFrontThumbnail &&
                      isImage(applicantCnicDocumentFront) ? (
                        <div className="btn-div">
                          <img
                            src={applicantCnicDocumentFrontThumbnail}
                            alt="Applicant CNIC Front"
                            width="80"
                          />
                          
                        </div>
                      ) : (
                        <span>
                          {isPdf(applicantCnicDocumentFront) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                              
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Front
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_applicant_cnic_document_front"
                        name="iv_applicant_cnic_document_front"
                        type="file"
                        onChange={ApplicantCnicDocumentFront}
                      />
                    </Button>
                    <Box className="documentError">
                      {applicantCnicDocumentFront == ""
                        ? applicantCnicFrontError
                        : null}
                    </Box>
                  </>
                )}
                </div>
                <div className="upload-wrap">
                {applicantCnicDocumentBack ? (
                  <>
                    <Button
                      component="label"
                      className="upload-preview"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setApplicantCnicDocumentBack("");
                          }}
                        />
                      }
                    >
                      {applicantCnicDocumentBackThumbnail &&
                      isImage(applicantCnicDocumentBack) ? (
                        <div className="btn-div">
                          <img
                            src={applicantCnicDocumentBackThumbnail}
                            alt="Applicant CNIC Back"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(applicantCnicDocumentBack) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Back
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_applicant_cnic_document_back"
                        name="iv_applicant_cnic_document_back"
                        type="file"
                        onChange={ApplicantCnicDocumentBack}
                      />
                    </Button>
                    <Box className="documentError">
                      {applicantCnicDocumentBack == ""
                        ? applicantCnicBackError
                        : null}
                    </Box>
                  </>
                )}
                </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} className="nc-doc-col">
                <div className="nc-doc-col-head">
                <Typography className="documentLabel doc-grid-label">
                  2- Property documents
                </Typography>
                <Box className="documentError">
                  {errors.iv_property_documents && touched.iv_property_documents
                    ? errors.iv_property_documents
                    : null}
                </Box>
                </div>
                <div className="doc-grid-uploads">
                <div className="upload-wrap">
                {propertyDocuments ? (
                  <>
                    <Button
                      component="label"
                      className="upload-preview"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setPropertDocuments("");
                          }}
                        />
                      }
                    >
                      {propertyDocumentsThumbnail &&
                      isImage(propertyDocuments) ? (
                        <div className="btn-div">
                          <img
                            src={propertyDocumentsThumbnail}
                            alt="Property Documents"
                            width="80"
                          />
                          
                        </div>
                      ) : (
                        <span>
                          {isPdf(propertyDocuments) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                              
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Upload
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_property_documents"
                        name="iv_property_documents"
                        type="file"
                        onChange={PropertDocuments}
                      />
                    </Button>
                    <Box className="documentError">
                      {propertyDocuments == "" ? propertyDocumentError : null}
                    </Box>
                  </>
                )}
                </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} className="nc-doc-col">
                <div className="nc-doc-col-head">
                <Typography className="documentLabel doc-grid-label">
                  3- Near-by Electricity Bill
                </Typography>
                <Box className="documentError">
                  {errors.iv_near_by_bill && touched.iv_near_by_bill
                    ? errors.iv_near_by_bill
                    : null}
                </Box>
                </div>
                <div className="doc-grid-uploads">
                <div className="upload-wrap">
                {nearByBillDocument ? (
                  <>
                    <Button
                      component="label"
                      className="upload-preview"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setNearByBillDocument("");
                          }}
                        />
                      }
                    >
                      {nearByBillDocumentThumbnail &&
                      isImage(nearByBillDocument) ? (
                        <div className="btn-div">
                          <img
                            src={nearByBillDocumentThumbnail}
                            alt="Near By Bill"
                            width="80"
                          />
                          
                        </div>
                      ) : (
                        <span>
                          {isPdf(nearByBillDocument) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                              
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Upload
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_near_by_bill"
                        name="iv_near_by_bill"
                        type="file"
                        onChange={NearByBillDocument}
                      />
                    </Button>
                    <Box className="documentError">
                      {nearByBillDocument == "" ? nearByBillError : null}
                    </Box>
                  </>
                )}
                </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} className="nc-doc-col">
                <div className="nc-doc-col-head">
                <Typography className="documentLabel doc-grid-label">
                  4- Wiring Test Report{" "}
                  {values.iv_connection_type === "Temporary" ||
                  values.iv_connection_type === "Electrification" ? (
                    <span style={{ color: "#A1A1A1" }}> (Optional)</span>
                  ) : null}
                </Typography>
                <Box className="documentError">
                  {errors.iv_test_wiring_report && touched.iv_test_wiring_report
                    ? errors.iv_test_wiring_report
                    : null}
                </Box>
                </div>
                <div className="doc-grid-uploads">
                <div className="upload-wrap">
                {testWiringReportDocument ? (
                  <>
                    <Button
                      component="label"
                      className="upload-preview"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setTestWiringReportDocument("");
                          }}
                        />
                      }
                    >
                      {testWiringReportDocumentThumbnail &&
                      isImage(testWiringReportDocument) ? (
                        <div className="btn-div">
                          <img
                            src={testWiringReportDocumentThumbnail}
                            alt="Test Wiring Report"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(testWiringReportDocument) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Upload
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_test_wiring_report"
                        name="iv_test_wiring_report"
                        type="file"
                        onChange={TestWiringReportDocument}
                      />
                    </Button>
                    <Box className="documentError">
                      {testWiringReportDocument == "" ? testWiringReportDocumentError : null}
                    </Box>
                  </>
                )}
                </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4} className="nc-doc-col">
                <div className="nc-doc-col-head">
                <Typography className="documentLabel doc-grid-label">
                  5- Any Other Doc.{" "}
                  {values.iv_circle &&
                  values.iv_circle.toString().slice(0, 2) === "14" ? null : (
                    <span style={{ color: "#A1A1A1" }}> (Optional)</span>
                  )}
                </Typography>
                <Box className="documentError">
                  {errors.iv_any_other_document && touched.iv_any_other_document
                    ? errors.iv_any_other_document
                    : null}
                </Box>
                </div>
                <div className="doc-grid-uploads">
                <div className="upload-wrap">
                {anyOtherDocument ? (
                  <>
                    <Button
                      component="label"
                      className="upload-preview"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setAnyOtherDocument("");
                          }}
                        />
                      }
                    >
                      {anyOtherDocumentThumbnail &&
                      isImage(anyOtherDocument) ? (
                        <div className="btn-div">
                          <img
                            src={anyOtherDocumentThumbnail}
                            alt="Any Other Doc."
                            width="80"
                          />
                          
                        </div>
                      ) : (
                        <span>
                          {isPdf(anyOtherDocument) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                              
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Upload
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_any_other_document"
                        name="iv_any_other_document"
                        type="file"
                        onChange={AnyOtherDocument}
                      />
                    </Button>
                    <Box className="documentError">
                      {anyOtherDocument == "" ? anyOtherDocumentError : null}
                    </Box>
                  </>
                )}
                </div>
                </div>
              </Grid>
              {values.iv_applicant_status === "Tenant" && (
                <>
                  <Grid item xs={12} sm={6} md={4} lg={4} className="nc-doc-col">
                    <div className="nc-doc-col-head">
                    <Typography className="documentLabel doc-grid-label">
                      6- Owner&apos;s CNIC.
                    </Typography>
                    <Box className="documentError">
                      {errors.iv_owner_cnic_document_front &&
                      touched.iv_owner_cnic_document_front
                        ? errors.iv_owner_cnic_document_front
                        : null}
                    </Box>
                    <Box className="documentError">
                      {errors.iv_owner_cnic_document_back &&
                      touched.iv_owner_cnic_document_back
                        ? errors.iv_owner_cnic_document_back
                        : null}
                    </Box>
                    </div>
                    <div className="doc-grid-uploads cnic-upload-pair">
                    <div className="upload-wrap">
                    {ownerCnicDocumentFront ? (
                      <>
                        <Button
                          component="label"
                          className="upload-preview"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setOwnerCnicDocumentFront("");
                              }}
                            />
                          }
                        >
                          {ownerCnicDocumentFrontThumbnail &&
                          isImage(ownerCnicDocumentFront) ? (
                            <div className="btn-div">
                              <img
                                src={ownerCnicDocumentFrontThumbnail}
                                alt="Owner CNIC Front"
                                width="80"
                              />
                              
                            </div>
                          ) : (
                            <span>
                              {isPdf(ownerCnicDocumentFront) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                  
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<FileUploadOutlinedIcon />}
                          className="btn"
                        >
                          Front
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_owner_cnic_document_front"
                            name="iv_owner_cnic_document_front"
                            type="file"
                            onChange={OwnerCnicDocumentFront}
                          />
                        </Button>
                        <Box className="documentError">
                          {ownerCnicDocumentFront == ""
                            ? ownerCnicFrontError
                            : null}
                        </Box>
                      </>
                    )}
                    </div>
                    <div className="upload-wrap">
                    {ownerCnicDocumentBack ? (
                      <>
                        <Button
                          component="label"
                          className="upload-preview"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setOwnerCnicDocumentBack("");
                              }}
                            />
                          }
                        >
                          {ownerCnicDocumentBackThumbnail &&
                          isImage(ownerCnicDocumentBack) ? (
                            <div className="btn-div">
                              <img
                                src={ownerCnicDocumentBackThumbnail}
                                alt="Owner CNIC Back"
                                width="80"
                              />
                              
                            </div>
                          ) : (
                            <span>
                              {isPdf(ownerCnicDocumentBack) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                  
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<FileUploadOutlinedIcon />}
                          className="btn"
                        >
                          Back
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_owner_cnic_document_back"
                            name="iv_owner_cnic_document_back"
                            type="file"
                            onChange={OwnerCnicDocumentBack}
                          />
                        </Button>
                        <Box className="documentError">
                          {ownerCnicDocumentBack == ""
                            ? ownerCnicBackError
                            : null}
                        </Box>
                      </>
                    )}
                    </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} className="nc-doc-col">
                    <div className="nc-doc-col-head">
                    <Typography className="documentLabel doc-grid-label">
                      7- NOC. from owner
                    </Typography>
                    <Box className="documentError">
                      {errors.iv_noc_owner && touched.iv_noc_owner
                        ? errors.iv_noc_owner
                        : null}
                    </Box>
                    </div>
                    <div className="doc-grid-uploads">
                    <div className="upload-wrap">
                    {nocOwnerDocument ? (
                      <>
                        <Button
                          component="label"
                          className="upload-preview"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setNocOwnerDocument("");
                              }}
                            />
                          }
                        >
                          {nocOwnerDocumentThumbnail &&
                          isImage(nocOwnerDocument) ? (
                            <div className="btn-div">
                              <img
                                src={nocOwnerDocumentThumbnail}
                                alt="Owner NOC"
                                width="80"
                              />
                              
                            </div>
                          ) : (
                            <span>
                              {isPdf(nocOwnerDocument) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                  
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<FileUploadOutlinedIcon />}
                          className="btn"
                        >
                          Upload
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_noc_owner"
                            name="iv_noc_owner"
                            type="file"
                            onChange={NocOwnerDocument}
                          />
                        </Button>
                        <Box className="documentError">
                          {nocOwnerDocument == "" ? nocError : null}
                        </Box>
                      </>
                    )}
                    </div>
                    </div>
                  </Grid>
                </>
              )}
              {values.iv_connection_type === "Industrial" ? (
                <>
                  <Grid item xs={12} sm={6} md={4} lg={4} className="nc-doc-col">
                    <div className="nc-doc-col-head">
                    <Typography className="documentLabel doc-grid-label">
                      {values.iv_applicant_status === "Owner" ? "6- " : "8- "}
                      Resolution from BoD&apos;s in the favour of signatory
                    </Typography>
                    <Box className="documentError">
                      {errors.iv_resolution && touched.iv_resolution
                        ? errors.iv_resolution
                        : null}
                    </Box>
                    </div>
                    <div className="doc-grid-uploads">
                    <div className="upload-wrap">
                    {resolutionDocument ? (
                      <>
                        <Button
                          component="label"
                          className="upload-preview"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setResolutionDocument("");
                              }}
                            />
                          }
                        >
                          {resolutionDocumentThumbnail &&
                          isImage(resolutionDocument) ? (
                            <div className="btn-div">
                              <img
                                src={resolutionDocumentThumbnail}
                                alt="Resolution Document"
                                width="80"
                              />
                              
                            </div>
                          ) : (
                            <span>
                              {isPdf(resolutionDocument) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                  
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<FileUploadOutlinedIcon />}
                          className="btn"
                        >
                          Upload
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_resolution"
                            name="iv_resolution"
                            type="file"
                            onChange={ResolutionDocument}
                          />
                        </Button>
                        <Box className="documentError">
                          {resolutionDocument == "" ? bodError : null}
                        </Box>
                      </>
                    )}
                    </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} className="nc-doc-col">
                    <div className="nc-doc-col-head">
                    <Typography className="documentLabel doc-grid-label">
                      {values.iv_applicant_status === "Owner" ? "7- " : "9- "}
                      Memorandum of association certificate{" "}
                      <span style={{ color: "#A1A1A1" }}>(Optional)</span>
                    </Typography>
                    <Box className="documentError">
                      {errors.iv_memo && touched.iv_memo
                        ? errors.iv_memo
                        : null}
                    </Box>
                    </div>
                    <div className="doc-grid-uploads">
                    <div className="upload-wrap">
                    {memorandumDocument ? (
                      <>
                        <Button
                          component="label"
                          className="upload-preview"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setMemorandumDocument("");
                              }}
                            />
                          }
                        >
                          {memorandumDocumentThumbnail &&
                          isImage(memorandumDocument) ? (
                            <div className="btn-div">
                              <img
                                src={memorandumDocumentThumbnail}
                                alt="Memorandum Document"
                                width="80"
                              />
                              
                            </div>
                          ) : (
                            <span>
                              {isPdf(memorandumDocument) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                  
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<FileUploadOutlinedIcon />}
                          className="btn"
                        >
                          Upload
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_memo"
                            name="iv_memo"
                            type="file"
                            onChange={MemorandumDocument}
                          />
                        </Button>
                        <Box className="documentError">
                          {memorandumDocument == "" ? memorandumError : null}
                        </Box>
                      </>
                    )}
                    </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} className="nc-doc-col">
                    <div className="nc-doc-col-head">
                    <Typography className="documentLabel doc-grid-label">
                      {values.iv_applicant_status === "Owner" ? "8- " : "10- "}
                      Certified copy of form-29
                    </Typography>
                    <Box className="documentError">
                      {errors.iv_form29initial && touched.iv_form29initial
                        ? errors.iv_form29initial
                        : null}
                    </Box>
                    </div>
                    <div className="doc-grid-uploads">
                    <div className="upload-wrap">
                    {form29Document ? (
                      <>
                        <Button
                          component="label"
                          className="upload-preview"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setForm29Document("");
                              }}
                            />
                          }
                        >
                          {form29DocumentThumbnail &&
                          isImage(form29Document) ? (
                            <div className="btn-div">
                              <img
                                src={form29DocumentThumbnail}
                                alt="Form-29 Document"
                                width="80"
                              />
                              
                            </div>
                          ) : (
                            <span>
                              {isPdf(form29Document) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                  
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<FileUploadOutlinedIcon />}
                          className="btn"
                        >
                          Upload
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_form29initial"
                            name="iv_form29initial"
                            type="file"
                            onChange={Form29Document}
                          />
                        </Button>
                        <Box className="documentError">
                          {form29Document == "" ? formError : null}
                        </Box>
                      </>
                    )}
                    </div>
                    </div>
                  </Grid>
                </>
              ) : null}
            </Grid>
            </div>
            {error && (
              <div className="nc-alert-wrap">
                <Error
                  error={error}
                  onClose={() => errorCloses()}
                  backgroundColor="#FFC0CB"
                  textColor="#bb0303"
                  iconColor="#bb0303"
                />
              </div>
            )}
            <div className="submit-area">
              <Button
                type="submit"
                variant="contained"
                className={`submit-btn${isDisabled ? ' Mui-disabled' : ''}`}
                disabled={isDisabled}
              >
                Submit
              </Button>
            </div>
          </form>
        </Box>
      </Grid>

      {/* Dialog for Location Picker */}
      <Dialog
        open={showLocationPicker}
        onClose={() => setShowLocationPicker(false)}
        className="dialog"
        fullWidth={true}
        maxWidth={"md"}
        PaperProps={{ style: { width: "100%", borderRadius: 20 } }}
      >
        <DialogTitle
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h2> Pick Location</h2>
          <CloseIcon
            onClick={() => setShowLocationPicker(false)}
            sx={{ color: "red", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent>
          <LocationPicker
            onLocationSelect={onLocationSelect}
            location={values.iv_location}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <FormSubmissionSuccessDialog
        open={newConnectionPopup}
        onClose={handleClose}
        title="Application submitted"
        message="Your New Connection Application is submitted successfully."
        trackingId={newConnectionId}
      />

      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop>
    </>
  );
};

export default NewConnectionForm;
